export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateOnly: { input: string; output: string };
  DateTime: { input: string; output: string };
  EmailAddress: { input: string; output: string };
  LocalTime: { input: string; output: string };
  LowercaseString: { input: string; output: string };
  Mixed: { input: any; output: any };
  PhoneNumber: { input: string; output: string };
  TimeZone: { input: string; output: string };
  Upload: { input: unknown; output: unknown };
  Void: { input: void; output: void };
};

export type AcceptOrganizationInviteInput = {
  inviteId: Scalars['ID']['input'];
};

export type AccountDeletionBlocker = {
  id: Scalars['ID']['output'];
  kind: AccountDeletionBlockerKind;
  title: Scalars['String']['output'];
};

export enum AccountDeletionBlockerKind {
  PaidSharedOrganization = 'PAID_SHARED_ORGANIZATION',
  SharedOrganization = 'SHARED_ORGANIZATION',
}

export type AccountDeletionPreview = {
  activeSubscriptions: Array<AccountDeletionSubscription>;
  blockers: Array<AccountDeletionBlocker>;
  canDelete: Scalars['Boolean']['output'];
  experienceCount: Scalars['Int']['output'];
  organizationCount: Scalars['Int']['output'];
  scheduleCount: Scalars['Int']['output'];
  sharedItems: Array<AccountDeletionSharedItem>;
  sharedSchedulesLosingFeeds: Scalars['Int']['output'];
};

export type AccountDeletionSharedItem = {
  id: Scalars['ID']['output'];
  kind: AccountDeletionSharedItemKind;
  title: Scalars['String']['output'];
};

export enum AccountDeletionSharedItemKind {
  Experience = 'EXPERIENCE',
  Schedule = 'SCHEDULE',
}

export type AccountDeletionSubscription = {
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  plan: SubscriptionPlan;
  status: UserSubscriptionStatus;
};

export type AddExperiencePermissionsInput = {
  experienceId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  users: Array<UserPermissionInput>;
};

export type AddFeedToExperienceInput = {
  experienceId: Scalars['ID']['input'];
  feedId: Scalars['ID']['input'];
};

export type AddOrganizationSeatPacksInput = {
  organizationId: Scalars['ID']['input'];
  packs: Scalars['Int']['input'];
};

export type AddSourceToExperienceInput = {
  experienceId: Scalars['ID']['input'];
  syncCutoff?: InputMaybe<Scalars['Int']['input']>;
  uri: Scalars['String']['input'];
};

export type AddTagToSchoolExperienceInput = {
  experienceId: Scalars['ID']['input'];
  tag: SchoolExperienceTag;
};

export enum AddToCalendarConfigAccess {
  Collaborator = 'COLLABORATOR',
  Off = 'OFF',
  Owner = 'OWNER',
  Public = 'PUBLIC',
}

export enum AddToCalendarConfigKeys {
  Access = 'access',
  IsInherited = 'isInherited',
  Mode = 'mode',
  RequiresAuth = 'requiresAuth',
}

export enum AddToCalendarConfigMode {
  EmailInvite = 'EMAIL_INVITE',
  Magic = 'MAGIC',
  None = 'NONE',
  WebLink = 'WEB_LINK',
}

export type AppConfig = {
  plannerTiers: Array<PlannerTierConfig>;
};

export type AssignDistrictToDistrictRequestInput = {
  leaId: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
};

export enum AttendeeStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
}

export enum AttributionOptions {
  AvatarFullName = 'AVATAR_FULL_NAME',
  None = 'NONE',
}

export enum AuthAction {
  LoginApple = 'LOGIN_APPLE',
  LoginEmailCode = 'LOGIN_EMAIL_CODE',
  LoginGoogle = 'LOGIN_GOOGLE',
  LoginPassword = 'LOGIN_PASSWORD',
  Register = 'REGISTER',
}

export type AvailabilityEntryDetails = {
  id: Scalars['ID']['output'];
  recurrences: Array<Recurrence>;
  timeZone: Scalars['TimeZone']['output'];
  title: Scalars['String']['output'];
};

export type AvailabilityResponse = {
  email: Scalars['LowercaseString']['output'];
  id: Scalars['ID']['output'];
  items: Array<EntryAvailability>;
  name: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type AvailabilityResponseInput = {
  email: Scalars['LowercaseString']['input'];
  items: Array<EntryAvailabilityInput>;
  name: Scalars['String']['input'];
};

export enum AvailabilityType {
  Full = 'FULL',
  Partial = 'PARTIAL',
}

export enum BannerOptions {
  None = 'NONE',
  Ratio_7_2 = 'RATIO_7_2',
  RatioIntrinsic = 'RATIO_INTRINSIC',
}

export type Base64FileInput = {
  data: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
};

export type Block = {
  id: Scalars['ID']['output'];
  layoutId: BlockLayouts;
  sequence: Scalars['Int']['output'];
  type: BlockTypes;
};

export type BlockDefinition = {
  layouts: Array<BlockLayouts>;
  slots: Array<InteractionSlotDefinition>;
  type: BlockTypes;
};

export enum BlockLayouts {
  CenterListHeader = 'CenterListHeader',
  CenterTitleHeader = 'CenterTitleHeader',
  DayByCategory = 'DayByCategory',
  DayByLabel = 'DayByLabel',
  DayBySource = 'DayBySource',
  DayByWho = 'DayByWho',
  LeftTitleHeader = 'LeftTitleHeader',
  ListByDay = 'ListByDay',
  ListByEvent = 'ListByEvent',
  ListByMonth = 'ListByMonth',
  ListByWeek = 'ListByWeek',
  ListByYear = 'ListByYear',
  ListFooter = 'ListFooter',
  ListHeader = 'ListHeader',
  MonthCardGrid = 'MonthCardGrid',
  None = 'None',
  PlannerFooter = 'PlannerFooter',
  PlannerHeader = 'PlannerHeader',
  PlannerPanel = 'PlannerPanel',
  PrintableFooter = 'PrintableFooter',
  ResponsiveMonth = 'ResponsiveMonth',
  ResponsiveWeekGrid = 'ResponsiveWeekGrid',
  SideHeader = 'SideHeader',
  VerticalListFooter = 'VerticalListFooter',
  VerticalListHeader = 'VerticalListHeader',
  Week7Column = 'Week7Column',
  WideVerticalListHeader = 'WideVerticalListHeader',
}

export enum BlockTypes {
  Collection = 'COLLECTION',
  Footer = 'FOOTER',
  Header = 'HEADER',
  Panel = 'PANEL',
}

export type Calendar = {
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  plannerCount: Scalars['Int']['output'];
  readonly: Scalars['Boolean']['output'];
  scheduleCount: Scalars['Int']['output'];
  uri: Scalars['String']['output'];
};

export type CalendarSubscription = {
  calendarId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  experienceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  integrationId: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  platform: EventExportPlatform;
};

export type CancelOrganizationSeatPackRemovalInput = {
  organizationId: Scalars['ID']['input'];
};

export type CanvaDesign = {
  id: Scalars['ID']['output'];
  source?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CanvaExportJob = {
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: DesignExportStatus;
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CanvaExportQuality {
  Poster = 'poster',
  Thumbnail = 'thumbnail',
}

export type Category = {
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type CategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySortOrderInput = {
  id: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type Chat = {
  createdAt: Scalars['DateTime']['output'];
  events: Array<Event>;
  experienceId?: Maybe<Scalars['ID']['output']>;
  experiencePublishedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobs: Array<MagicJob>;
  messages?: Maybe<Scalars['Mixed']['output']>;
  printable?: Maybe<ChatPrintable>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChatFrom = {
  magicJobId?: InputMaybe<Scalars['ID']['input']>;
  messages?: InputMaybe<Array<MessageInput>>;
};

export type ChatPrintable = {
  config: ChatPrintableConfig;
  url: Scalars['String']['output'];
};

export enum ChatPrintableBackground {
  Cloud_1 = 'cloud_1',
  Cloud_2 = 'cloud_2',
  Cloud_3 = 'cloud_3',
  Color_1 = 'color_1',
  Color_2 = 'color_2',
  Kawaii_1 = 'kawaii_1',
  Kawaii_2 = 'kawaii_2',
  Kawaii_3 = 'kawaii_3',
  None = 'none',
  Winter_1 = 'winter_1',
  Winter_2 = 'winter_2',
  Winter_3 = 'winter_3',
}

export type ChatPrintableBackgroundInfo = {
  id: ChatPrintableBackground;
  name: Scalars['String']['output'];
  swatchUrl?: Maybe<Scalars['String']['output']>;
};

export type ChatPrintableConfig = {
  background: ChatPrintableBackground;
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventListEndDate?: Maybe<Scalars['DateTime']['output']>;
  eventListStartDate?: Maybe<Scalars['DateTime']['output']>;
  isEmojiEnabled: Scalars['Boolean']['output'];
  isEndTimeEnabled: Scalars['Boolean']['output'];
  isLocationEnabled: Scalars['Boolean']['output'];
  isStartTimeEnabled: Scalars['Boolean']['output'];
  isYearEnabled: Scalars['Boolean']['output'];
  layout: ChatPrintableLayout;
  styleId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ChatPrintableConfigInfo = {
  backgrounds: Array<ChatPrintableBackgroundInfo>;
};

export type ChatPrintableConfigInput = {
  background: ChatPrintableBackground;
  description?: InputMaybe<Scalars['String']['input']>;
  eventListEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventListStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isEmojiEnabled: Scalars['Boolean']['input'];
  isEndTimeEnabled: Scalars['Boolean']['input'];
  isLocationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStartTimeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isYearEnabled: Scalars['Boolean']['input'];
  layout: ChatPrintableLayout;
  styleId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum ChatPrintableLayout {
  Default = 'default',
  PlannerCalendar = 'plannerCalendar',
  PlannerMonth = 'plannerMonth',
  PlannerWeek = 'plannerWeek',
  PrintableCalendar = 'printableCalendar',
  PrintableCustom = 'printableCustom',
  PrintableList = 'printableList',
  PrintableListVertical = 'printableListVertical',
  PrintableWeek = 'printableWeek',
  PrintableYearly3BoxMonthCard = 'printableYearly3BoxMonthCard',
  PrintableYearly6BoxMonthCard = 'printableYearly6BoxMonthCard',
  PrintableYearlyMonthCard = 'printableYearlyMonthCard',
}

export type CheckSlugAvailabilityInput = {
  slug: Scalars['LowercaseString']['input'];
};

export type ChildExperience = {
  childIndex: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: ExperienceChildConfigKind;
  layoutId: ExperienceLayouts;
  title: Scalars['String']['output'];
  type: ExperienceTypes;
};

export enum ColorTypes {
  Custom = 'CUSTOM',
  Standard = 'STANDARD',
}

export type CompleteMagicJobInput = {
  magicJobId: Scalars['ID']['input'];
  timeZone: Scalars['TimeZone']['input'];
};

export type CopyExperienceInput = {
  experienceId: Scalars['ID']['input'];
  timeZone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateCanvaExportInput = {
  canvaDesignId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  quality: CanvaExportQuality;
};

export type CreateChatInput = {
  createPrintable?: InputMaybe<Scalars['Boolean']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<ChatFrom>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sharesExperienceCollection?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone: Scalars['TimeZone']['input'];
};

export type CreateChildExperienceInput = {
  config: ExperienceChildConfigName;
  experienceId: Scalars['String']['input'];
};

export type CreateDistrictInput = {
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  studentCount: Scalars['Int']['input'];
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  websiteUrl: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type CreateDistrictRequestInput = {
  email: Scalars['LowercaseString']['input'];
  leaId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEntryInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  entryId?: InputMaybe<Scalars['ID']['input']>;
  exclusions?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  hidden?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  inclusions?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  labels?: InputMaybe<Array<LabelIdInput>>;
  locationWithPlace?: InputMaybe<LocationInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  recurrences: Array<RecurrenceInput>;
  scheduleId: Scalars['ID']['input'];
  source?: InputMaybe<CreateEntrySource>;
  timeZone: Scalars['TimeZone']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  whoLabels?: InputMaybe<Array<LabelIdInput>>;
};

export enum CreateEntrySource {
  Magic = 'MAGIC',
  Manual = 'MANUAL',
}

export type CreateEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  end: EventDateInput;
  experienceId: Scalars['String']['input'];
  kind?: InputMaybe<EventItemKind>;
  locationWithPlace?: InputMaybe<LocationInput>;
  metadata?: InputMaybe<EventMetadataInput>;
  rrule?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  start: EventDateInput;
  title: Scalars['String']['input'];
};

export type CreateEventMessageInput = {
  body: Scalars['String']['input'];
  deliveryTimeType: DeliveryTimeType;
  eventId: Scalars['ID']['input'];
  eventMessageId?: InputMaybe<Scalars['ID']['input']>;
  experienceId: Scalars['ID']['input'];
  fixedDeliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  fixedTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  hybridDeliveryTime?: InputMaybe<Scalars['LocalTime']['input']>;
  hybridRelativeTime?: InputMaybe<HybridRelativeTime>;
  hybridTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  instance?: InputMaybe<Scalars['DateTime']['input']>;
  recipients?: InputMaybe<Array<Scalars['Int']['input']>>;
  relativeTimeToEntryStart?: InputMaybe<Scalars['Int']['input']>;
  relativeTimeToEntryStartDirection?: InputMaybe<TimeDirection>;
  relativeTimeToEntryStartUnit?: InputMaybe<TimeUnit>;
  sendToEveryone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEventsInput = {
  events: Array<CreateEventInput>;
  experienceId: Scalars['String']['input'];
};

export type CreateExperienceCategoryInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  color: Scalars['String']['input'];
  colorName?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CreateExperienceInput = {
  bold?: InputMaybe<Scalars['Int']['input']>;
  colorType?: InputMaybe<ColorTypes>;
  config?: InputMaybe<ExperienceConfigName>;
  customAlpha?: InputMaybe<Scalars['Float']['input']>;
  customHue?: InputMaybe<Scalars['Int']['input']>;
  customLightness?: InputMaybe<Scalars['Int']['input']>;
  customSaturation?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventListDisplay?: InputMaybe<EventListDisplay>;
  eventListEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventListStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<ExperienceFrom>;
  hue?: InputMaybe<Scalars['Int']['input']>;
  layout?: InputMaybe<ExperienceLayouts>;
  licenseId?: InputMaybe<Scalars['String']['input']>;
  lightness?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  saturation?: InputMaybe<Scalars['Int']['input']>;
  sparkle?: InputMaybe<Scalars['Int']['input']>;
  styleId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExperienceTypes;
  version?: InputMaybe<Scalars['Int']['input']>;
  vibe?: InputMaybe<ExperienceVibe>;
};

export type CreateExperienceLabelInput = {
  experienceId: Scalars['ID']['input'];
  labelId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
  type: LabelType;
};

export type CreateMagicJobFrom = {
  base64File?: InputMaybe<Base64FileInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMagicJobInput = {
  context?: InputMaybe<MagicJobContextInput>;
  descriptionFooter?: InputMaybe<Scalars['String']['input']>;
  from: CreateMagicJobFrom;
  model?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  source: MagicJobSource;
  systemPromptId?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  titlePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlannerFromPromptInput = {
  prompt: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePrintableForChatInput = {
  chatId: Scalars['ID']['input'];
  config?: InputMaybe<ChatPrintableConfigInput>;
};

export type CreateSchoolExperienceInput = {
  districtId: Scalars['ID']['input'];
  districtName: Scalars['String']['input'];
  districtUrl: Scalars['String']['input'];
  eventTitlePrefix?: InputMaybe<Scalars['String']['input']>;
  pdfFrom?: InputMaybe<PdfFrom>;
  slug: Scalars['LowercaseString']['input'];
  timeZone: Scalars['TimeZone']['input'];
};

export type CreateShortTitlesInput = {
  experienceId: Scalars['ID']['input'];
};

export type CustomArtifact = {
  current: CustomArtifactContentCounts;
  designedFor?: Maybe<CustomArtifactContentCounts>;
  document: Scalars['String']['output'];
  experienceId: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  versions: Array<CustomArtifactVersion>;
};

export type CustomArtifactContentCounts = {
  dayCount: Scalars['Int']['output'];
  occurrenceCount: Scalars['Int']['output'];
};

export type CustomArtifactVersion = {
  createdAt: Scalars['DateTime']['output'];
  instructions: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type DeleteChildExperienceInput = {
  experienceId: Scalars['ID']['input'];
};

export type DeleteEventInput = {
  eventId: Scalars['ID']['input'];
  for: EventFor;
};

export type DeleteEventMessageInput = {
  eventMessageId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
};

export type DeleteEventsFromSchoolExperienceInput = {
  experienceId: Scalars['ID']['input'];
};

export type DeleteExperienceCategoryInput = {
  categoryId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
};

export type DeleteExperienceInput = {
  experienceId: Scalars['ID']['input'];
};

export type DeleteExperienceLabelInput = {
  experienceId: Scalars['ID']['input'];
  labelId: Scalars['ID']['input'];
};

export type DeletePrintableForChatInput = {
  chatId: Scalars['ID']['input'];
};

export type DeliveryAttempt = {
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['PhoneNumber']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum DeliveryTimeType {
  Fixed = 'FIXED',
  Hybrid = 'HYBRID',
  Relative = 'RELATIVE',
}

export enum DesignExportStatus {
  Failed = 'failed',
  InProgress = 'in_progress',
  Success = 'success',
}

export type DirectoryTag = {
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type DisableExperienceTemplateInput = {
  experienceId: Scalars['ID']['input'];
};

export type District = {
  city: Scalars['String']['output'];
  districtExperiences: Array<DistrictExperienceLink>;
  districtRequests: Array<DistrictRequest>;
  id: Scalars['ID']['output'];
  leaId: Scalars['String']['output'];
  leaType: DistrictLeaType;
  name: Scalars['String']['output'];
  schoolCount: Scalars['Int']['output'];
  schools: Array<DistrictSchool>;
  state: Scalars['String']['output'];
  studentCount: Scalars['Int']['output'];
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type DistrictExperienceLink = {
  directoryTagId: Scalars['ID']['output'];
  editUrl: Scalars['String']['output'];
  eventCount?: Maybe<Scalars['Int']['output']>;
  experienceId: Scalars['ID']['output'];
  experienceTitle: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isHumanReviewed: Scalars['Boolean']['output'];
  isPurchasable: Scalars['Boolean']['output'];
  pdfLastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  qaFeedback: Array<ExperienceQaFeedback>;
  qaResult?: Maybe<ExperienceQaResult>;
  tags: Array<Scalars['String']['output']>;
  updateRequestCount: Scalars['Int']['output'];
};

export type DistrictInfo = {
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leaId: Scalars['String']['output'];
  leaType: DistrictLeaType;
  name: Scalars['String']['output'];
  schoolCount: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  studentCount: Scalars['Int']['output'];
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export enum DistrictLeaType {
  Charter = 'CHARTER',
  Custom = 'CUSTOM',
  FederalAgency = 'FEDERAL_AGENCY',
  Other = 'OTHER',
  Regular = 'REGULAR',
  RegularComponent = 'REGULAR_COMPONENT',
  ServiceAgency = 'SERVICE_AGENCY',
  Specialized = 'SPECIALIZED',
  StateAgency = 'STATE_AGENCY',
  SupervisoryUnion = 'SUPERVISORY_UNION',
}

export type DistrictRequest = {
  createdAt: Scalars['DateTime']['output'];
  district?: Maybe<DistrictInfo>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  requesters: Array<DistrictRequester>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DistrictRequestFilterInput = {
  type?: InputMaybe<DistrictRequestType>;
};

export enum DistrictRequestType {
  All = 'all',
  Custom = 'custom',
}

export type DistrictRequester = {
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DistrictSchool = {
  city: Scalars['String']['output'];
  gradeHigh?: Maybe<Scalars['String']['output']>;
  gradeLow?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ncesschId: Scalars['String']['output'];
  schoolType: SchoolType;
  state: Scalars['String']['output'];
};

export type EditDistrictInput = {
  districtId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum EditorPermissions {
  AddToCalendar = 'ADD_TO_CALENDAR',
  EntryCreate = 'ENTRY_CREATE',
  EntryDelete = 'ENTRY_DELETE',
  EntryUpdate = 'ENTRY_UPDATE',
  Messages = 'MESSAGES',
  PermissionsModify = 'PERMISSIONS_MODIFY',
  Rsvp = 'RSVP',
  ScheduleExport = 'SCHEDULE_EXPORT',
  ScheduleImport = 'SCHEDULE_IMPORT',
  ScheduleModifySettings = 'SCHEDULE_MODIFY_SETTINGS',
  ScheduleRename = 'SCHEDULE_RENAME',
  ScheduleView = 'SCHEDULE_VIEW',
  SnippetEdit = 'SNIPPET_EDIT',
  SnippetView = 'SNIPPET_VIEW',
}

export type EmailLoginCodeResult = {
  isNewUser: Scalars['Boolean']['output'];
  user: User;
};

export type EnableExperienceTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EntriesJob = {
  createdAt: Scalars['DateTime']['output'];
  entries?: Maybe<Array<Entry>>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  file?: Maybe<EntriesJobFile>;
  headerId?: Maybe<ScheduleHeaderId>;
  id: Scalars['ID']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  scheduleId: Scalars['ID']['output'];
  status: JobStatus;
  title?: Maybe<Scalars['String']['output']>;
  type: EntriesJobType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntriesJobFile = {
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  mimetype: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum EntriesJobType {
  File = 'FILE',
  Prompt = 'PROMPT',
}

export type Entry = {
  attachments: Array<EntryAttachment>;
  category?: Maybe<Category>;
  contextId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  exclusions: Array<Scalars['DateTime']['output']>;
  feed?: Maybe<FeedSummary>;
  hidden: Array<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inclusions: Array<Scalars['DateTime']['output']>;
  invites: Array<EntryInvite>;
  /** @deprecated Use rsvpInfo instead */
  isFollowing: Scalars['Boolean']['output'];
  labels: Array<Label>;
  locationWithPlace?: Maybe<Location>;
  messages: Array<EntryMessage>;
  notes?: Maybe<Scalars['String']['output']>;
  recurrences: Array<Recurrence>;
  rsvpInfo: RsvpInfo;
  rsvpSettings: EntryRsvpSettings;
  status: EntryStatus;
  timeZone: Scalars['TimeZone']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: EntryType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whoLabels: Array<Label>;
};

export type EntryAttachment = {
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EntryAvailability = {
  entry: AvailabilityEntryDetails;
  id: Scalars['ID']['output'];
  instance: Scalars['DateTime']['output'];
  note?: Maybe<Scalars['String']['output']>;
  status: AvailabilityType;
};

export type EntryAvailabilityInput = {
  entryId: Scalars['ID']['input'];
  instance: Scalars['DateTime']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: AvailabilityType;
};

export type EntryInvite = {
  email: Scalars['LowercaseString']['output'];
  id: Scalars['ID']['output'];
  memberSubmission?: Maybe<Array<MemberFormFieldData>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status: AttendeeStatus;
};

export type EntryMessage = {
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryAttempts: Array<DeliveryAttempt>;
  deliveryTimeType: DeliveryTimeType;
  entry: Entry;
  fixedDeliveryTime?: Maybe<Scalars['DateTime']['output']>;
  fixedTimeZone?: Maybe<Scalars['TimeZone']['output']>;
  hybridDeliveryTime?: Maybe<Scalars['LocalTime']['output']>;
  hybridRelativeTime?: Maybe<HybridRelativeTime>;
  hybridTimeZone?: Maybe<Scalars['TimeZone']['output']>;
  id: Scalars['ID']['output'];
  instance: Scalars['DateTime']['output'];
  reason?: Maybe<MessageStatusReason>;
  recipients: Array<Member>;
  relativeTimeToEntryStart?: Maybe<Scalars['Int']['output']>;
  relativeTimeToEntryStartDirection?: Maybe<TimeDirection>;
  relativeTimeToEntryStartUnit?: Maybe<TimeUnit>;
  sendAt: Scalars['DateTime']['output'];
  sendToEveryone: Scalars['Boolean']['output'];
  status?: Maybe<MessageStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntryMessageInput = {
  body: Scalars['String']['input'];
  deliveryTimeType: DeliveryTimeType;
  fixedDeliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  fixedTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  hybridDeliveryTime?: InputMaybe<Scalars['LocalTime']['input']>;
  hybridRelativeTime?: InputMaybe<HybridRelativeTime>;
  hybridTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instance: Scalars['DateTime']['input'];
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  relativeTimeToEntryStart?: InputMaybe<Scalars['Int']['input']>;
  relativeTimeToEntryStartDirection?: InputMaybe<TimeDirection>;
  relativeTimeToEntryStartUnit?: InputMaybe<TimeUnit>;
  sendToEveryone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntryRsvpSettings = {
  enabled: Scalars['Boolean']['output'];
};

export enum EntryStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum EntryType {
  Feed = 'FEED',
  Schedule = 'SCHEDULE',
}

export enum ErrorCodes {
  AccountDeletionBlocked = 'ACCOUNT_DELETION_BLOCKED',
  AccountDeletionConfirmationMismatch = 'ACCOUNT_DELETION_CONFIRMATION_MISMATCH',
  AccountDeletionThrottled = 'ACCOUNT_DELETION_THROTTLED',
  AccountSuspended = 'ACCOUNT_SUSPENDED',
  AdminConsentGranted = 'ADMIN_CONSENT_GRANTED',
  AdminConsentRequired = 'ADMIN_CONSENT_REQUIRED',
  AppleTokenInvalid = 'APPLE_TOKEN_INVALID',
  BadRequest = 'BAD_REQUEST',
  BlockNotFound = 'BLOCK_NOT_FOUND',
  BotDetected = 'BOT_DETECTED',
  CalendarSubscriptionNotFound = 'CALENDAR_SUBSCRIPTION_NOT_FOUND',
  CanvaRequestInvalid = 'CANVA_REQUEST_INVALID',
  CategoryInUse = 'CATEGORY_IN_USE',
  CategoryNotFound = 'CATEGORY_NOT_FOUND',
  ChatAlreadyHasExperience = 'CHAT_ALREADY_HAS_EXPERIENCE',
  ChatExperienceCollectionMismatch = 'CHAT_EXPERIENCE_COLLECTION_MISMATCH',
  ChatExperienceMismatch = 'CHAT_EXPERIENCE_MISMATCH',
  ChatMessagesMissing = 'CHAT_MESSAGES_MISSING',
  ChatMessageLimitExceeded = 'CHAT_MESSAGE_LIMIT_EXCEEDED',
  ChatNotFound = 'CHAT_NOT_FOUND',
  ChildConfigNotAvailable = 'CHILD_CONFIG_NOT_AVAILABLE',
  ChildExperienceNotAChild = 'CHILD_EXPERIENCE_NOT_A_CHILD',
  ChildExperienceNotAFeedSource = 'CHILD_EXPERIENCE_NOT_A_FEED_SOURCE',
  ChildExperienceRequiresPlanner = 'CHILD_EXPERIENCE_REQUIRES_PLANNER',
  ConflictFormNotSupported = 'CONFLICT_FORM_NOT_SUPPORTED',
  CreateMagicJobFailed = 'CREATE_MAGIC_JOB_FAILED',
  CustomArtifactRenderFailed = 'CUSTOM_ARTIFACT_RENDER_FAILED',
  EmailRecipientSuppressed = 'EMAIL_RECIPIENT_SUPPRESSED',
  EmailRequired = 'EMAIL_REQUIRED',
  EntryAlreadyAddedToCalendar = 'ENTRY_ALREADY_ADDED_TO_CALENDAR',
  EntryAttachmentNotFound = 'ENTRY_ATTACHMENT_NOT_FOUND',
  EntryMessageInPast = 'ENTRY_MESSAGE_IN_PAST',
  EntryMessageNotFound = 'ENTRY_MESSAGE_NOT_FOUND',
  EntryMessageNotScheduled = 'ENTRY_MESSAGE_NOT_SCHEDULED',
  EntryNotFound = 'ENTRY_NOT_FOUND',
  EntryScheduledMessageLimitReached = 'ENTRY_SCHEDULED_MESSAGE_LIMIT_REACHED',
  EventDateInvalid = 'EVENT_DATE_INVALID',
  EventDateRuleInvalid = 'EVENT_DATE_RULE_INVALID',
  EventDateTypeMismatch = 'EVENT_DATE_TYPE_MISMATCH',
  EventInviteNotFound = 'EVENT_INVITE_NOT_FOUND',
  EventIsReadOnly = 'EVENT_IS_READ_ONLY',
  EventListDisplayInvalid = 'EVENT_LIST_DISPLAY_INVALID',
  EventMessageInstanceRequired = 'EVENT_MESSAGE_INSTANCE_REQUIRED',
  EventMessageInvalidRecipient = 'EVENT_MESSAGE_INVALID_RECIPIENT',
  EventMessageNotAllowed = 'EVENT_MESSAGE_NOT_ALLOWED',
  EventMessageNotFound = 'EVENT_MESSAGE_NOT_FOUND',
  EventMessageNotScheduled = 'EVENT_MESSAGE_NOT_SCHEDULED',
  EventNotFound = 'EVENT_NOT_FOUND',
  EventNotPartOfChat = 'EVENT_NOT_PART_OF_CHAT',
  EventNotPartOfExperience = 'EVENT_NOT_PART_OF_EXPERIENCE',
  ExperienceFeedLimitReached = 'EXPERIENCE_FEED_LIMIT_REACHED',
  ExperienceLayoutInvalid = 'EXPERIENCE_LAYOUT_INVALID',
  ExperienceMoveNotAllowed = 'EXPERIENCE_MOVE_NOT_ALLOWED',
  ExperienceNotFound = 'EXPERIENCE_NOT_FOUND',
  ExperiencePublishStateError = 'EXPERIENCE_PUBLISH_STATE_ERROR',
  ExperienceSlugExists = 'EXPERIENCE_SLUG_EXISTS',
  ExperienceTemplateInvalid = 'EXPERIENCE_TEMPLATE_INVALID',
  FeedInvalid = 'FEED_INVALID',
  FeedInUse = 'FEED_IN_USE',
  FeedNotFound = 'FEED_NOT_FOUND',
  FeedUrlFailed = 'FEED_URL_FAILED',
  FeedUrlForbidden = 'FEED_URL_FORBIDDEN',
  FeedUrlNotFound = 'FEED_URL_NOT_FOUND',
  FeedUrlUnavailable = 'FEED_URL_UNAVAILABLE',
  FileRequired = 'FILE_REQUIRED',
  GoogleTokenInvalid = 'GOOGLE_TOKEN_INVALID',
  IntegrationDisconnected = 'INTEGRATION_DISCONNECTED',
  IntegrationEventExportInvalidAttendeeEmail = 'INTEGRATION_EVENT_EXPORT_INVALID_ATTENDEE_EMAIL',
  IntegrationEventExportRateLimited = 'INTEGRATION_EVENT_EXPORT_RATE_LIMITED',
  IntegrationEventExportRejected = 'INTEGRATION_EVENT_EXPORT_REJECTED',
  IntegrationEventExportUnavailable = 'INTEGRATION_EVENT_EXPORT_UNAVAILABLE',
  IntegrationInsufficientScope = 'INTEGRATION_INSUFFICIENT_SCOPE',
  IntegrationNotFound = 'INTEGRATION_NOT_FOUND',
  InteractionAppNotFound = 'INTERACTION_APP_NOT_FOUND',
  InteractionConfigInvalid = 'INTERACTION_CONFIG_INVALID',
  InteractionSlotNotFound = 'INTERACTION_SLOT_NOT_FOUND',
  InvalidFileType = 'INVALID_FILE_TYPE',
  InvalidInviteCode = 'INVALID_INVITE_CODE',
  InvalidLabel = 'INVALID_LABEL',
  InvalidLogin = 'INVALID_LOGIN',
  InvalidPermission = 'INVALID_PERMISSION',
  InvalidRefreshToken = 'INVALID_REFRESH_TOKEN',
  InvalidToken = 'INVALID_TOKEN',
  JobNotFound = 'JOB_NOT_FOUND',
  LabelExists = 'LABEL_EXISTS',
  LabelInUse = 'LABEL_IN_USE',
  LabelNotFound = 'LABEL_NOT_FOUND',
  LayoutConfigInvalid = 'LAYOUT_CONFIG_INVALID',
  LayoutNotFound = 'LAYOUT_NOT_FOUND',
  LibraryItemNotFound = 'LIBRARY_ITEM_NOT_FOUND',
  MagicFileLimitReached = 'MAGIC_FILE_LIMIT_REACHED',
  MagicJobAlreadyOpened = 'MAGIC_JOB_ALREADY_OPENED',
  MagicJobNotFound = 'MAGIC_JOB_NOT_FOUND',
  MagicJobNotReady = 'MAGIC_JOB_NOT_READY',
  MemberFormInvalidEntry = 'MEMBER_FORM_INVALID_ENTRY',
  MemberFormNotSupported = 'MEMBER_FORM_NOT_SUPPORTED',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  MerValidationErrFailedValidation = 'MER_VALIDATION_ERR_FAILED_VALIDATION',
  NotLoggedIn = 'NOT_LOGGED_IN',
  NoContent = 'NO_CONTENT',
  NoResponse = 'NO_RESPONSE',
  OauthConnectionNotFound = 'OAUTH_CONNECTION_NOT_FOUND',
  OrganizationInviteNotFound = 'ORGANIZATION_INVITE_NOT_FOUND',
  OrganizationNotFound = 'ORGANIZATION_NOT_FOUND',
  OrganizationPlanInactive = 'ORGANIZATION_PLAN_INACTIVE',
  OrganizationSeatLimitReached = 'ORGANIZATION_SEAT_LIMIT_REACHED',
  OrganizationSeatPacksUnavailable = 'ORGANIZATION_SEAT_PACKS_UNAVAILABLE',
  OrganizationSeatPackChangePending = 'ORGANIZATION_SEAT_PACK_CHANGE_PENDING',
  OrganizationSeatPackPaymentFailed = 'ORGANIZATION_SEAT_PACK_PAYMENT_FAILED',
  OrganizationSeatPackRemovalBlocked = 'ORGANIZATION_SEAT_PACK_REMOVAL_BLOCKED',
  PasswordRegistrationDisabled = 'PASSWORD_REGISTRATION_DISABLED',
  PaymentRequired = 'PAYMENT_REQUIRED',
  PermissionNotGranted = 'PERMISSION_NOT_GRANTED',
  PlannerChildrenRequiresPlannerType = 'PLANNER_CHILDREN_REQUIRES_PLANNER_TYPE',
  PlannerConfigRequired = 'PLANNER_CONFIG_REQUIRED',
  PlannerLicenseAlreadyUsed = 'PLANNER_LICENSE_ALREADY_USED',
  PlannerLicenseRequired = 'PLANNER_LICENSE_REQUIRED',
  PlannerUpgradeInvalidTier = 'PLANNER_UPGRADE_INVALID_TIER',
  PrintableNotFound = 'PRINTABLE_NOT_FOUND',
  PromptRequestInvalid = 'PROMPT_REQUEST_INVALID',
  PromptRequestTooLong = 'PROMPT_REQUEST_TOO_LONG',
  PromptResponseParseError = 'PROMPT_RESPONSE_PARSE_ERROR',
  PromptResponseTooLong = 'PROMPT_RESPONSE_TOO_LONG',
  QuickEntriesJobNotFound = 'QUICK_ENTRIES_JOB_NOT_FOUND',
  QuickEntriesPageNotFound = 'QUICK_ENTRIES_PAGE_NOT_FOUND',
  QuickEntryNotFound = 'QUICK_ENTRY_NOT_FOUND',
  ResetTokenExpired = 'RESET_TOKEN_EXPIRED',
  ResetTokenInvalid = 'RESET_TOKEN_INVALID',
  ResetTokenUsed = 'RESET_TOKEN_USED',
  RsvpNotFound = 'RSVP_NOT_FOUND',
  ScheduleMemberLimitReached = 'SCHEDULE_MEMBER_LIMIT_REACHED',
  ScheduleNotFound = 'SCHEDULE_NOT_FOUND',
  ScheduleSlugExists = 'SCHEDULE_SLUG_EXISTS',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SnippetNotFound = 'SNIPPET_NOT_FOUND',
  SourceInvalid = 'SOURCE_INVALID',
  SourceNotFound = 'SOURCE_NOT_FOUND',
  SourceRefreshThrottled = 'SOURCE_REFRESH_THROTTLED',
  SubscriberExists = 'SUBSCRIBER_EXISTS',
  SubscriberNotFound = 'SUBSCRIBER_NOT_FOUND',
  TokenExpired = 'TOKEN_EXPIRED',
  TokenRevoked = 'TOKEN_REVOKED',
  UnknownError = 'UNKNOWN_ERROR',
  UploadFailed = 'UPLOAD_FAILED',
  UploadLimitExceeded = 'UPLOAD_LIMIT_EXCEEDED',
  UserExists = 'USER_EXISTS',
  UserNotFound = 'USER_NOT_FOUND',
  VerificationCodeExpired = 'VERIFICATION_CODE_EXPIRED',
  VerificationCodeInvalid = 'VERIFICATION_CODE_INVALID',
}

export type Event = {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  end: EventDate;
  exclusions: Array<Scalars['String']['output']>;
  /** @deprecated Only reports GOOGLE exports. Use exports, which covers every integration. */
  exportState: EventExportState;
  exportedToExperiences: Array<ExportedExperience>;
  exports: Array<EventExport>;
  firstStartDate: Scalars['DateOnly']['output'];
  firstStartDateTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isAllDay: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  kind: EventItemKind;
  lastEndDate: Scalars['DateOnly']['output'];
  lastEndDateTime: Scalars['DateTime']['output'];
  locationWithPlace?: Maybe<Location>;
  metadata: EventItemMetadata;
  origin?: Maybe<EventOrigin>;
  rrule?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  start: EventDate;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type EventExportsArgs = {
  filters?: InputMaybe<ListEventExportInput>;
};

export type EventCardDefinition = {
  layout: EventCardLayouts;
  supportsDate: Scalars['Boolean']['output'];
  supportsDescription: Scalars['Boolean']['output'];
  supportsEmoji: Scalars['Boolean']['output'];
  supportsLocation: Scalars['Boolean']['output'];
};

export enum EventCardLayouts {
  GridEventBullet = 'GridEventBullet',
  GridEventCard = 'GridEventCard',
  GridEventLine = 'GridEventLine',
  GridEventText = 'GridEventText',
  GridItem = 'GridItem',
  ListEventBulleted = 'ListEventBulleted',
  ListEventCard = 'ListEventCard',
  ListEventCardWithImage = 'ListEventCardWithImage',
  ListItem = 'ListItem',
  ListItemCondensed = 'ListItemCondensed',
  None = 'None',
  TableItem = 'TableItem',
}

export type EventDate = {
  date?: Maybe<Scalars['DateOnly']['output']>;
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
};

export type EventDateInput = {
  dateOnly?: InputMaybe<EventDateOnlyInput>;
  dateTime?: InputMaybe<EventDateTimeInput>;
};

export type EventDateOnlyInput = {
  date: Scalars['DateOnly']['input'];
};

export type EventDateTimeInput = {
  dateTime: Scalars['DateTime']['input'];
  timeZone: Scalars['TimeZone']['input'];
};

export type EventExport = {
  autoUpdate: Scalars['Boolean']['output'];
  calendarId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['ID']['output'];
  externalId: Scalars['String']['output'];
  externalLink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationId?: Maybe<Scalars['ID']['output']>;
  invites: Array<Scalars['String']['output']>;
  platform: EventExportPlatform;
  sequence?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['ID']['output'];
};

export enum EventExportPlatform {
  Google = 'GOOGLE',
  Outlook = 'OUTLOOK',
}

export enum EventExportState {
  AutoUpdate = 'autoUpdate',
  ExportOutdated = 'exportOutdated',
  ExportUpToDate = 'exportUpToDate',
  None = 'none',
}

export type EventFor = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  magicJobId?: InputMaybe<Scalars['ID']['input']>;
};

export type EventFrom = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  magicJobId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EventItemKind {
  Blockout = 'BLOCKOUT',
  Event = 'EVENT',
}

export type EventItemMetadata = {
  category?: Maybe<ExperienceCategory>;
  emoji?: Maybe<Scalars['String']['output']>;
  hidden: Array<Scalars['DateTime']['output']>;
  inheritedHidden: Array<Scalars['DateTime']['output']>;
  kind?: Maybe<EventItemKind>;
  labels: Array<ExperienceLabel>;
  notes?: Maybe<Scalars['String']['output']>;
  whoLabels: Array<ExperienceLabel>;
};

export enum EventListDisplay {
  All = 'ALL',
  Custom = 'CUSTOM',
  Full = 'FULL',
  Past = 'PAST',
  Upcoming = 'UPCOMING',
}

export type EventMessage = {
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryAttempts: Array<DeliveryAttempt>;
  deliveryTimeType: DeliveryTimeType;
  event: EventMessageEvent;
  eventId: Scalars['ID']['output'];
  fixedDeliveryTime?: Maybe<Scalars['DateTime']['output']>;
  fixedTimeZone?: Maybe<Scalars['TimeZone']['output']>;
  hybridDeliveryTime?: Maybe<Scalars['LocalTime']['output']>;
  hybridRelativeTime?: Maybe<HybridRelativeTime>;
  hybridTimeZone?: Maybe<Scalars['TimeZone']['output']>;
  id: Scalars['ID']['output'];
  instance: Scalars['DateTime']['output'];
  reason?: Maybe<MessageStatusReason>;
  recipients: Array<EventMessageRecipient>;
  relativeTimeToEntryStart?: Maybe<Scalars['Int']['output']>;
  relativeTimeToEntryStartDirection?: Maybe<TimeDirection>;
  relativeTimeToEntryStartUnit?: Maybe<TimeUnit>;
  sendAt: Scalars['DateTime']['output'];
  sendToEveryone: Scalars['Boolean']['output'];
  status?: Maybe<MessageStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventMessageEvent = {
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllDay: Scalars['Boolean']['output'];
  start: EventDate;
  title: Scalars['String']['output'];
};

export type EventMessageRecipient = {
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type EventMetadataInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  kind?: InputMaybe<EventItemKind>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  whoLabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EventOrigin = {
  color?: Maybe<Scalars['String']['output']>;
  editUrl?: Maybe<Scalars['String']['output']>;
  experienceId?: Maybe<Scalars['ID']['output']>;
  kind: FeedOriginKind;
  publicUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum EventTextSizes {
  Default = 'DEFAULT',
  Large = 'LARGE',
}

export type Experience = {
  accentBackgroundEnabled: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  attributionDisplay: AttributionOptions;
  bannerDisplay: BannerOptions;
  bannerImageId?: Maybe<Scalars['String']['output']>;
  bannerImageType?: Maybe<ImageTypes>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  blocks: Array<Block>;
  bold: Scalars['Int']['output'];
  categories: Array<ExperienceCategory>;
  chatId?: Maybe<Scalars['String']['output']>;
  children: Array<ChildExperience>;
  collectionId: Scalars['String']['output'];
  colorLegendEnabled: Scalars['Boolean']['output'];
  colorMode: ExperienceColorMode;
  colorPalette: Scalars['String']['output'];
  colorType: ColorTypes;
  config?: Maybe<ExperienceConfigName>;
  createdAt: Scalars['DateTime']['output'];
  customAlpha: Scalars['Float']['output'];
  customHue?: Maybe<Scalars['Int']['output']>;
  customLightness?: Maybe<Scalars['Int']['output']>;
  customSaturation?: Maybe<Scalars['Int']['output']>;
  datesInPrimaryColor: Scalars['Boolean']['output'];
  defaultChildExperienceId?: Maybe<Scalars['ID']['output']>;
  defaultInteractionAppId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEnabled: Scalars['Boolean']['output'];
  directoryTags: Array<DirectoryTag>;
  eventCardCategoryEnabled: Scalars['Boolean']['output'];
  eventCardDateEnabled: Scalars['Boolean']['output'];
  eventCardDescriptionEnabled: Scalars['Boolean']['output'];
  eventCardEmojiEnabled: Scalars['Boolean']['output'];
  eventCardEndTimeEnabled: Scalars['Boolean']['output'];
  eventCardLabelsEnabled: Scalars['Boolean']['output'];
  eventCardLayoutId: EventCardLayouts;
  eventCardLocationEnabled: Scalars['Boolean']['output'];
  eventCardStartTimeEnabled: Scalars['Boolean']['output'];
  eventCardTruncateNamesEnabled: Scalars['Boolean']['output'];
  eventCardYearEnabled: Scalars['Boolean']['output'];
  eventDescriptionFooter?: Maybe<Scalars['String']['output']>;
  eventListDisplay: EventListDisplay;
  eventListEndDate?: Maybe<Scalars['DateTime']['output']>;
  eventListStartDate?: Maybe<Scalars['DateTime']['output']>;
  eventTextSize: EventTextSizes;
  eventTitlePrefix?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  feeds: Array<ExperienceFeed>;
  fundraiserImageUrl?: Maybe<Scalars['String']['output']>;
  fundraiserName?: Maybe<Scalars['String']['output']>;
  headerTitleEnabled: Scalars['Boolean']['output'];
  headerTitleSize: HeaderTitleSizes;
  heroDisplay: HeroOptions;
  heroImageId?: Maybe<Scalars['String']['output']>;
  heroImageType?: Maybe<ImageTypes>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  heroPreviewImageUrl?: Maybe<Scalars['String']['output']>;
  highlightToday: Scalars['Boolean']['output'];
  hue: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interactionApps: Array<InteractionApp>;
  interactionSlots: Array<InteractionSlot>;
  isCopyable: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  isSaved: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  kind?: Maybe<ExperienceChildConfigKind>;
  labels: Array<ExperienceLabel>;
  layout: LayoutDefinition;
  layoutId: ExperienceLayouts;
  lightness: Scalars['Int']['output'];
  logoDisplay: LogoOptions;
  logoImageId?: Maybe<Scalars['String']['output']>;
  logoImageType?: Maybe<ImageTypes>;
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  muteWeekendDatesEnabled: Scalars['Boolean']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  org?: Maybe<ExperienceOrg>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  owner: ExperienceOwner;
  primaryColor: Scalars['String']['output'];
  printableConfig?: Maybe<PrintableConfig>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedSlug?: Maybe<Scalars['String']['output']>;
  role: Role;
  saturation: Scalars['Int']['output'];
  shadeWeekendsEnabled: Scalars['Boolean']['output'];
  sparkle: Scalars['Int']['output'];
  style: ExperienceStyles;
  styleId?: Maybe<Scalars['String']['output']>;
  subscribeEnabled: Scalars['Boolean']['output'];
  theme?: Maybe<ExperienceTheme>;
  timeFormat: ExperienceTimeFormat;
  timeZone: Scalars['TimeZone']['output'];
  timeZoneDisplay: TimeZoneDisplay;
  title: Scalars['String']['output'];
  type: ExperienceTypes;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
  vibe?: Maybe<ExperienceVibe>;
  viewerCalendarSubscriptions: Array<CalendarSubscription>;
  weekStartDay?: Maybe<Scalars['Int']['output']>;
  whoLabels: Array<ExperienceLabel>;
};

export type ExperienceEventsArgs = {
  filters?: InputMaybe<ListExperienceEventInput>;
};

export type ExperienceInteractionSlotsArgs = {
  filters?: InputMaybe<ListExperienceInteractionSlotInput>;
};

export type ExperienceCategory = {
  color?: Maybe<Scalars['String']['output']>;
  colorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export enum ExperienceChildConfigCategory {
  Calendar = 'CALENDAR',
  Cards = 'CARDS',
  List = 'LIST',
}

export type ExperienceChildConfigInfo = {
  category: ExperienceChildConfigCategory;
  kind: ExperienceChildConfigKind;
  layoutId: ExperienceLayouts;
  name: ExperienceChildConfigName;
  title: Scalars['String']['output'];
};

export enum ExperienceChildConfigKind {
  Interactive = 'INTERACTIVE',
  Printable = 'PRINTABLE',
}

export enum ExperienceChildConfigName {
  Cards = 'CARDS',
  DayByCategory = 'DAY_BY_CATEGORY',
  ImageCards = 'IMAGE_CARDS',
  ListBulleted = 'LIST_BULLETED',
  Month = 'MONTH',
  PrintableCustom = 'PRINTABLE_CUSTOM',
  PrintableList = 'PRINTABLE_LIST',
  PrintableMonth = 'PRINTABLE_MONTH',
  PrintableMonthCards = 'PRINTABLE_MONTH_CARDS',
  PrintableMonthCards_6Box = 'PRINTABLE_MONTH_CARDS_6BOX',
  PrintableMonthCards_12Box = 'PRINTABLE_MONTH_CARDS_12BOX',
  PrintableWeek = 'PRINTABLE_WEEK',
  PrintableWeekColumns = 'PRINTABLE_WEEK_COLUMNS',
  SideBySideSplit = 'SIDE_BY_SIDE_SPLIT',
  Week = 'WEEK',
  WeekColumns = 'WEEK_COLUMNS',
}

export enum ExperienceColorMode {
  Bold = 'BOLD',
  Light = 'LIGHT',
}

export enum ExperienceConfigName {
  Default = 'DEFAULT',
  MagicPlanner = 'MAGIC_PLANNER',
  Printable = 'PRINTABLE',
  SchoolPlanner_2026_27 = 'SCHOOL_PLANNER_2026_27',
  SummerPlan_2026 = 'SUMMER_PLAN_2026',
}

export type ExperienceFeed = {
  accessRevokedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<ExperienceCategory>;
  color: Scalars['String']['output'];
  editUrl?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: FeedOriginKind;
  labels: Array<ExperienceLabel>;
  originDeletedAt?: Maybe<Scalars['DateTime']['output']>;
  originalTitle?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  whoLabels: Array<ExperienceLabel>;
};

export type ExperienceFrom = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  feedId?: InputMaybe<Scalars['ID']['input']>;
  magicJobId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ExperienceImageTypes {
  Banner = 'BANNER',
  Hero = 'HERO',
  Logo = 'LOGO',
}

export type ExperienceLabel = {
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export enum ExperienceLayouts {
  DayByCategory = 'dayByCategory',
  Grid = 'grid',
  ListTable = 'listTable',
  ListVertical = 'listVertical',
  ListVerticalBulleted = 'listVerticalBulleted',
  ListVerticalBulletedCondensed = 'listVerticalBulletedCondensed',
  ListVerticalWithImages = 'listVerticalWithImages',
  Planner = 'planner',
  PlannerCalendar = 'plannerCalendar',
  PlannerMonth = 'plannerMonth',
  PlannerWeek = 'plannerWeek',
  PrintVertical = 'printVertical',
  PrintableCalendar = 'printableCalendar',
  PrintableCustom = 'printableCustom',
  PrintableList = 'printableList',
  PrintableListVertical = 'printableListVertical',
  PrintableWeek = 'printableWeek',
  PrintableYearly3BoxMonthCard = 'printableYearly3BoxMonthCard',
  PrintableYearly6BoxMonthCard = 'printableYearly6BoxMonthCard',
  PrintableYearlyMonthCard = 'printableYearlyMonthCard',
  SideHeader = 'sideHeader',
  SideHeaderV2 = 'sideHeaderV2',
  SingleImage = 'singleImage',
  Week = 'week',
}

export type ExperienceOrg = {
  effectiveTier: UserTier;
  id: Scalars['ID']['output'];
  seatTier: UserTier;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  type: OrganizationType;
};

export type ExperienceOrganizationPermission = {
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  role: Role;
};

export type ExperienceOwner = {
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum ExperiencePageLayouts {
  DayByCategory = 'dayByCategory',
  Grid = 'grid',
  ListTable = 'listTable',
  ListVertical = 'listVertical',
  ListVerticalBulleted = 'listVerticalBulleted',
  ListVerticalBulletedCondensed = 'listVerticalBulletedCondensed',
  ListVerticalWithImages = 'listVerticalWithImages',
  PlannerCalendar = 'plannerCalendar',
  PlannerMonth = 'plannerMonth',
  PlannerWeek = 'plannerWeek',
  PrintVertical = 'printVertical',
  PrintableWeek = 'printableWeek',
  SideHeader = 'sideHeader',
  SideHeaderV2 = 'sideHeaderV2',
  SingleImage = 'singleImage',
  Week = 'week',
}

export type ExperiencePermissionRemovalPreview = {
  feedsGoingDark: Array<ExperienceFeed>;
};

export enum ExperiencePrintableLayouts {
  PlannerCalendar = 'plannerCalendar',
  PlannerMonth = 'plannerMonth',
  PlannerWeek = 'plannerWeek',
  PrintableCalendar = 'printableCalendar',
  PrintableCustom = 'printableCustom',
  PrintableList = 'printableList',
  PrintableListVertical = 'printableListVertical',
  PrintableWeek = 'printableWeek',
  PrintableYearly3BoxMonthCard = 'printableYearly3BoxMonthCard',
  PrintableYearly6BoxMonthCard = 'printableYearly6BoxMonthCard',
  PrintableYearlyMonthCard = 'printableYearlyMonthCard',
}

export type ExperienceQaFeedback = {
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: ExperienceQaFeedbackType;
};

export enum ExperienceQaFeedbackType {
  Confirm = 'CONFIRM',
  Report = 'REPORT',
}

export type ExperienceQaResult = {
  confidenceScore: QaConfidenceScore;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  pdfComplexity: QaPdfComplexity;
  report: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verdict: QaVerdict;
};

export type ExperienceRef = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum ExperienceStyles {
  Block = 'BLOCK',
  Color = 'COLOR',
  Gradient = 'GRADIENT',
  Pattern = 'PATTERN',
  Scene = 'SCENE',
}

export enum ExperienceSubscriptionTypes {
  Current = 'CURRENT',
  CurrentAndFuture = 'CURRENT_AND_FUTURE',
  Future = 'FUTURE',
}

export type ExperienceTemplate = {
  createUrl: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
};

export type ExperienceTheme = {
  bannerImageId?: Maybe<Scalars['String']['output']>;
  bannerImageType?: Maybe<ImageTypes>;
  bold?: Maybe<Scalars['Int']['output']>;
  colorType?: Maybe<ColorTypes>;
  createdAt: Scalars['DateTime']['output'];
  customHue?: Maybe<Scalars['Int']['output']>;
  customLightness?: Maybe<Scalars['Int']['output']>;
  customSaturation?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  heroImageId?: Maybe<Scalars['String']['output']>;
  heroImageType?: Maybe<ImageTypes>;
  hue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lightness?: Maybe<Scalars['Int']['output']>;
  logoImageId?: Maybe<Scalars['String']['output']>;
  logoImageType?: Maybe<ImageTypes>;
  name: Scalars['String']['output'];
  saturation?: Maybe<Scalars['Int']['output']>;
  sparkle?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ExperienceTimeFormat {
  HourOnly = 'HOUR_ONLY',
  TwelveHour = 'TWELVE_HOUR',
  TwelveHourCompact = 'TWELVE_HOUR_COMPACT',
  TwelveHourNoMeridiem = 'TWELVE_HOUR_NO_MERIDIEM',
  TwentyFourHour = 'TWENTY_FOUR_HOUR',
}

export enum ExperienceTypes {
  Page = 'PAGE',
  Planner = 'PLANNER',
  Printable = 'PRINTABLE',
}

export enum ExperienceVibe {
  Planner = 'PLANNER',
  Summer = 'SUMMER',
}

export type ExportEventsInput = {
  attendees?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  calendarId: Scalars['String']['input'];
  eventIds: Array<Scalars['ID']['input']>;
  from?: InputMaybe<EventFrom>;
  integrationId: Scalars['ID']['input'];
};

export type ExportedExperience = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum Feature {
  CustomColors = 'CUSTOM_COLORS',
  CustomTheme = 'CUSTOM_THEME',
  CustomUrl = 'CUSTOM_URL',
}

export type Feed = {
  category?: Maybe<Category>;
  emoji?: Maybe<Scalars['String']['output']>;
  entries: Array<Entry>;
  error?: Maybe<Scalars['String']['output']>;
  erroredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  integration?: Maybe<FeedIntegration>;
  labels: Array<Label>;
  primarySchedule?: Maybe<FeedPrimarySchedule>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: FeedType;
  url: Scalars['String']['output'];
  whoLabels: Array<Label>;
};

export type FeedEntriesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeedIntegration = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: PublicUser;
  type: IntegrationType;
};

export enum FeedOriginKind {
  Experience = 'EXPERIENCE',
  Google = 'GOOGLE',
  Ics = 'ICS',
  Outlook = 'OUTLOOK',
}

export type FeedPrimarySchedule = {
  id: Scalars['ID']['output'];
};

export type FeedSecret = {
  enabled: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
};

export type FeedSummary = {
  id: Scalars['ID']['output'];
  primarySchedule?: Maybe<FeedPrimarySchedule>;
  title?: Maybe<Scalars['String']['output']>;
  type: FeedType;
  url: Scalars['String']['output'];
};

export enum FeedType {
  External = 'EXTERNAL',
  Google = 'GOOGLE',
  Internal = 'INTERNAL',
}

export type FindDistrictsInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['ID']['input']>;
  districtName?: InputMaybe<Scalars['String']['input']>;
  hasExperiences?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  noTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  qaConfidenceScore?: InputMaybe<QaConfidenceScore>;
  qaPdfComplexity?: InputMaybe<QaPdfComplexity>;
  qaVerdict?: InputMaybe<QaVerdict>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<FindDistrictsSortField>;
  state?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FindDistrictsResult = {
  items: Array<District>;
  totalCount: Scalars['Int']['output'];
};

export enum FindDistrictsSortField {
  EventCount = 'eventCount',
  RequestCount = 'requestCount',
  SchoolCount = 'schoolCount',
  StudentCount = 'studentCount',
}

export type FlagNoSchoolEventsInput = {
  experienceId: Scalars['ID']['input'];
};

export type GetCanvaExportJobInput = {
  canvaExportJobId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
};

export type GetChatInput = {
  chatId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCustomArtifactInput = {
  experienceId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GetDistrictRequestsInput = {
  filters?: InputMaybe<DistrictRequestFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<GetDistrictRequestsSortField>;
};

export type GetDistrictRequestsResult = {
  items: Array<DistrictRequest>;
  totalCount: Scalars['Int']['output'];
};

export enum GetDistrictRequestsSortField {
  CreatedAt = 'createdAt',
  DistrictName = 'districtName',
  RequestCount = 'requestCount',
}

export type GetEventExportsInput = {
  eventId: Scalars['ID']['input'];
};

export type GetEventForExperienceInput = {
  eventId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
};

export type GetEventMessageRecipientsInput = {
  experienceId: Scalars['ID']['input'];
};

export type GetEventMessagesInput = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  experienceId: Scalars['ID']['input'];
};

export type GetExperienceInput = {
  experienceId: Scalars['String']['input'];
};

export type GetExperiencePermissionsInput = {
  experienceId: Scalars['String']['input'];
};

export type GetExperienceThemesInput = {
  experienceId: Scalars['String']['input'];
};

export type GetExperienceUpdateRequestersInput = {
  experienceId: Scalars['ID']['input'];
};

export type GetLayoutInput = {
  layoutId: ExperienceLayouts;
};

export type GetLibraryInput = {
  allOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<LibraryItemFilterInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetMagicJobInput = {
  magicJobId: Scalars['ID']['input'];
};

export type GetOrganizationInvitesInput = {
  organizationId: Scalars['ID']['input'];
};

export type GetOrganizationMembersInput = {
  organizationId: Scalars['ID']['input'];
};

export type GetPublishedChildExperienceInput = {
  childExperienceId: Scalars['ID']['input'];
  experienceSlug: Scalars['String']['input'];
};

export type GetPublishedExperienceInput = {
  experienceSlug: Scalars['String']['input'];
};

export enum HeaderTitleSizes {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL',
}

export enum HeroOptions {
  None = 'NONE',
  RatioIntrinsic = 'RATIO_INTRINSIC',
}

export enum HybridRelativeTime {
  DayAfter = 'DAY_AFTER',
  DayBefore = 'DAY_BEFORE',
  DayOf = 'DAY_OF',
}

export enum IdentityStrategy {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Password = 'PASSWORD',
}

export enum ImageTypes {
  Custom = 'CUSTOM',
  Pdf = 'PDF',
}

export type ImportChatInput = {
  chatId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
};

export type ImportChatIntoScheduleInput = {
  chatId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type ImportMagicJobInput = {
  experienceId: Scalars['ID']['input'];
  magicJobId: Scalars['ID']['input'];
};

export type ImportMagicJobIntoScheduleInput = {
  magicJobId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type InstallInteractionAppInput = {
  applicationName: InteractionAppNames;
  experienceId: Scalars['String']['input'];
  isAutoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultApp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Integration = {
  accountKind?: Maybe<IntegrationAccountKind>;
  calendars: Array<Calendar>;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  status: IntegrationStatus;
  type: IntegrationType;
};

export enum IntegrationAccountKind {
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL',
}

export enum IntegrationStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
}

export enum IntegrationType {
  Canva = 'CANVA',
  GoogleCalendar = 'GOOGLE_CALENDAR',
  OutlookCalendar = 'OUTLOOK_CALENDAR',
}

export type InteractionApp = {
  applicationName: InteractionAppNames;
  config: Array<InteractionAppSetting>;
  id: Scalars['ID']['output'];
};

export type InteractionAppConfigInput = {
  config: Array<InteractionAppSettingInput>;
  experienceId: Scalars['String']['input'];
  interactionAppId: Scalars['String']['input'];
};

export enum InteractionAppNames {
  AddToCalendar = 'ADD_TO_CALENDAR',
  SaveEvent = 'SAVE_EVENT',
  /** Extended by app schema - don't use _empty */
  Empty = '_empty',
}

export type InteractionAppSetting = {
  setting: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InteractionAppSettingInput = {
  setting: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InteractionSlot = {
  blockId: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interactionAppId?: Maybe<Scalars['String']['output']>;
  slotIndex: Scalars['Int']['output'];
};

export type InteractionSlotDefinition = {
  size: SlotSize;
};

export type InviteOrganizationMembersInput = {
  members: Array<OrganizationMemberInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export enum JobStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Reviewed = 'REVIEWED',
  Waiting = 'WAITING',
}

export type Label = {
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type LabelIdInput = {
  id: Scalars['ID']['input'];
};

export type LabelInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type LabelSortOrderInput = {
  id: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
};

export enum LabelType {
  Default = 'DEFAULT',
  Who = 'WHO',
}

export type LayoutDefinition = {
  attributionOptions: Array<AttributionOptions>;
  bannerOptions: Array<BannerOptions>;
  blocks: Array<BlockDefinition>;
  cardOptions: Array<EventCardDefinition>;
  eventListDisplayOptions: Array<EventListDisplay>;
  heroOptions: Array<HeroOptions>;
  id: ExperienceLayouts;
  logoOptions: Array<LogoOptions>;
  supportsDescription: Scalars['Boolean']['output'];
  supportsWeekStart: Scalars['Boolean']['output'];
  type: ExperienceTypes;
};

export type LeaveExperienceInput = {
  experienceId: Scalars['ID']['input'];
};

export type LibraryItem = {
  chatId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isEventPresent?: Maybe<Scalars['Boolean']['output']>;
  isSaved: Scalars['Boolean']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  permissions?: Maybe<UserPermissions>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  styles?: Maybe<LibraryItemStyles>;
  timeZone: Scalars['TimeZone']['output'];
  title: Scalars['String']['output'];
  type: LibraryItemType;
};

export type LibraryItemIsEventPresentArgs = {
  eventId: Scalars['String']['input'];
};

export type LibraryItemFilterInput = {
  types?: InputMaybe<Array<LibraryItemType>>;
};

export type LibraryItemStyles = {
  accentBackgroundEnabled?: Maybe<Scalars['Boolean']['output']>;
  bold: Scalars['Int']['output'];
  colorMode?: Maybe<ExperienceColorMode>;
  colorPalette?: Maybe<Scalars['String']['output']>;
  hue: Scalars['Int']['output'];
  lightness: Scalars['Int']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  saturation: Scalars['Int']['output'];
  vibe?: Maybe<ExperienceVibe>;
};

export enum LibraryItemType {
  AvailabilityCalendar = 'AVAILABILITY_CALENDAR',
  CollaborativeCalendar = 'COLLABORATIVE_CALENDAR',
  ConflictCalendar = 'CONFLICT_CALENDAR',
  Page = 'PAGE',
  Planner = 'PLANNER',
  Printable = 'PRINTABLE',
}

export type ListCanvaDesignInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
};

export type ListCanvaDesignResult = {
  cursor?: Maybe<Scalars['String']['output']>;
  data: Array<CanvaDesign>;
};

export type ListEventExportInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<EventExportPlatform>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ListExperienceEventInput = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateOnly']['input']>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
  whoLabels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ListExperienceInteractionSlotInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Location = {
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum LogoOptions {
  None = 'NONE',
  Square = 'SQUARE',
}

export type MagicJob = {
  canEdit: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailSubject?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  file?: Maybe<MagicJobFile>;
  files: Array<MagicJobFile>;
  id: Scalars['ID']['output'];
  outcome?: Maybe<MagicJobOutcome>;
  prompt?: Maybe<Scalars['String']['output']>;
  source: MagicJobSource;
  sourceText?: Maybe<Scalars['String']['output']>;
  status: MagicJobStatus;
  statusIcon?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['TimeZone']['output'];
  title?: Maybe<Scalars['String']['output']>;
  toolCallId?: Maybe<Scalars['String']['output']>;
  type: MagicJobType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MagicJobContextInput = {
  id: Scalars['ID']['input'];
  toolCallId?: InputMaybe<Scalars['String']['input']>;
  type: MagicJobContextType;
};

export enum MagicJobContextType {
  Chat = 'CHAT',
}

export type MagicJobFile = {
  contentId?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum MagicJobOutcome {
  Error = 'ERROR',
  Incomplete = 'INCOMPLETE',
  LowQuality = 'LOW_QUALITY',
  NoEvents = 'NO_EVENTS',
  Ok = 'OK',
}

export enum MagicJobSource {
  Android = 'ANDROID',
  App = 'APP',
  Canva = 'CANVA',
  ChromeExtension = 'CHROME_EXTENSION',
  Email = 'EMAIL',
  Ios = 'IOS',
  Web = 'WEB',
}

export enum MagicJobStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Waiting = 'WAITING',
}

export enum MagicJobType {
  File = 'FILE',
  Text = 'TEXT',
}

export type Member = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['PhoneNumber']['output'];
};

export enum MemberFieldType {
  PhoneNumber = 'PHONE_NUMBER',
  Text = 'TEXT',
}

export type MemberForm = {
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<MemberFormField>;
  id: Scalars['ID']['output'];
  scheduleId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type MemberFormField = {
  formId: Scalars['ID']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  type: MemberFieldType;
};

export type MemberFormFieldData = {
  fieldId: Scalars['ID']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MemberFormFieldDataInput = {
  fieldId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MemberInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['PhoneNumber']['input'];
};

export type MessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  parts: Array<Scalars['Mixed']['input']>;
  role: MessageInputRole;
};

export enum MessageInputRole {
  Assistant = 'assistant',
  System = 'system',
  User = 'user',
}

export enum MessageStatusReason {
  NotEntitled = 'NOT_ENTITLED',
  NoRecipients = 'NO_RECIPIENTS',
  ScheduledTimeout = 'SCHEDULED_TIMEOUT',
  ScheduleChanged = 'SCHEDULE_CHANGED',
  SourceAccessRevoked = 'SOURCE_ACCESS_REVOKED',
}

export enum MessageStatusType {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
}

export type MoveExperienceToOrganizationInput = {
  experienceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type Mutation = {
  _empty?: Maybe<Scalars['String']['output']>;
  acceptOrganizationInvite: Organization;
  addExperiencePermissions?: Maybe<Scalars['Void']['output']>;
  addFeedToExperience: ExperienceFeed;
  addMembers: Array<Member>;
  addOrganizationSeatPacks?: Maybe<Scalars['Void']['output']>;
  addSchedulePermissions?: Maybe<Scalars['Void']['output']>;
  addSourceToExperience: ExperienceFeed;
  addSourceToSchedule: FeedSummary;
  addTagToSchoolExperience?: Maybe<Scalars['Void']['output']>;
  assignDistrictToDistrictRequest?: Maybe<Scalars['Void']['output']>;
  cancelOrganizationSeatPackRemoval?: Maybe<Scalars['Void']['output']>;
  changePassword?: Maybe<Scalars['Void']['output']>;
  completeMagicJob: MagicJob;
  completeOnboarding?: Maybe<Scalars['Void']['output']>;
  configureInteractionApp: InteractionApp;
  copyExperience: Experience;
  copyPublicSchedule: Scalars['ID']['output'];
  copySchedule: Scalars['ID']['output'];
  createCanvaExportJob: CanvaExportJob;
  createCategory: Category;
  createChat: Chat;
  createChildExperience: Experience;
  createDistrict?: Maybe<Scalars['Void']['output']>;
  createDistrictRequest?: Maybe<Scalars['Void']['output']>;
  createEntriesJobFromFile?: Maybe<EntriesJob>;
  createEntriesJobFromPrompt?: Maybe<EntriesJob>;
  createEntry: Entry;
  createEntryAttachment?: Maybe<EntryAttachment>;
  createEntryMessage: EntryMessage;
  createEntryMessages: Array<EntryMessage>;
  createEvent: Event;
  createEventMessage: EventMessage;
  createEvents: Array<Event>;
  createExperience: Experience;
  createExperienceCategory: ExperienceCategory;
  createExperienceLabel: ExperienceLabel;
  createLabel: Label;
  createMagicJob: MagicJob;
  createPlannerFromPrompt: Experience;
  createPrintableForChat?: Maybe<ChatPrintable>;
  /** @deprecated Potentially used by old mobile app versions */
  createQuickEntriesJobFromFile: QuickEntriesJob;
  /** @deprecated Potentially used by old mobile app versions */
  createQuickEntriesJobFromPrompt: QuickEntriesJob;
  createSchedule: Schedule;
  createScheduleFromFeed: Schedule;
  createScheduleFromTemplate: Schedule;
  createSchoolExperience: Experience;
  createShortTitles?: Maybe<Scalars['Void']['output']>;
  createSnippet: Snippet;
  deleteAccount?: Maybe<Scalars['Void']['output']>;
  deleteCategory?: Maybe<Scalars['Void']['output']>;
  deleteChildExperience?: Maybe<Scalars['Void']['output']>;
  deleteEntry?: Maybe<Scalars['Void']['output']>;
  deleteEntryMessage?: Maybe<Scalars['Void']['output']>;
  deleteEvent?: Maybe<Scalars['Void']['output']>;
  deleteEventMessage?: Maybe<Scalars['Void']['output']>;
  deleteEventsFromSchoolExperience?: Maybe<Scalars['Void']['output']>;
  deleteExperience?: Maybe<Scalars['Void']['output']>;
  deleteExperienceCategory?: Maybe<Scalars['Void']['output']>;
  deleteExperienceLabel?: Maybe<Scalars['Void']['output']>;
  deleteFeedSecret?: Maybe<Scalars['Void']['output']>;
  deleteIntegration?: Maybe<Scalars['Void']['output']>;
  deleteLabel?: Maybe<Scalars['Void']['output']>;
  deletePrintableForChat?: Maybe<Scalars['Void']['output']>;
  deleteSchedule?: Maybe<Scalars['Void']['output']>;
  deleteSnippet?: Maybe<Scalars['Void']['output']>;
  disableExperienceTemplate?: Maybe<Scalars['Void']['output']>;
  editDistrict?: Maybe<Scalars['Void']['output']>;
  enableExperienceTemplate: ExperienceTemplate;
  exportEvents: Array<EventExport>;
  exportQuickEntries: Array<QuickEntryExport>;
  flagNoSchoolEvents?: Maybe<Scalars['Void']['output']>;
  followEntry?: Maybe<Scalars['Void']['output']>;
  generateFeedSecret: Scalars['String']['output'];
  importChat: Experience;
  importChatIntoSchedule: Schedule;
  importMagicJob: Experience;
  importMagicJobIntoSchedule: Schedule;
  installInteractionApp: Experience;
  inviteOrganizationMembers?: Maybe<Scalars['Void']['output']>;
  leaveExperience?: Maybe<Scalars['Void']['output']>;
  leaveSchedule?: Maybe<Scalars['Void']['output']>;
  login: User;
  logout?: Maybe<Scalars['Void']['output']>;
  moveExperienceToOrganization: Experience;
  notifyOwner?: Maybe<Scalars['Void']['output']>;
  publishJobEntries?: Maybe<Scalars['Void']['output']>;
  publishSchoolExperience?: Maybe<Scalars['Void']['output']>;
  qaSchoolExperience?: Maybe<Scalars['Void']['output']>;
  rateMagicJob?: Maybe<Scalars['Void']['output']>;
  refreshFeed?: Maybe<Feed>;
  refreshSourceForExperience?: Maybe<ExperienceFeed>;
  register: User;
  removeEntryAttachment?: Maybe<Scalars['Void']['output']>;
  removeEvent?: Maybe<Scalars['Void']['output']>;
  removeEventExports: Array<EventExport>;
  removeExperienceOrganizationPermission?: Maybe<Scalars['Void']['output']>;
  removeExperiencePermission?: Maybe<Scalars['Void']['output']>;
  removeFeedFromExperience?: Maybe<Scalars['Void']['output']>;
  removeFeedFromSchedule?: Maybe<Scalars['Void']['output']>;
  removeImageForEvent?: Maybe<Scalars['Void']['output']>;
  removeImageForExperience?: Maybe<Scalars['Void']['output']>;
  removeMember?: Maybe<Scalars['Void']['output']>;
  removeOrganizationMember?: Maybe<Scalars['Void']['output']>;
  removeProfileImage?: Maybe<Scalars['Void']['output']>;
  removeSchedulePermission?: Maybe<Scalars['Void']['output']>;
  removeSchoolExperienceFundraiserImage?: Maybe<Scalars['Void']['output']>;
  removeSourceFromExperience?: Maybe<Scalars['Void']['output']>;
  removeTagFromSchoolExperience?: Maybe<Scalars['Void']['output']>;
  renameLibraryItem: RenameLibraryItemPayload;
  repeatMagicJob: MagicJob;
  requestAccess?: Maybe<Scalars['Void']['output']>;
  requestEmailLoginCode?: Maybe<Scalars['Void']['output']>;
  requestEmailVerification?: Maybe<Scalars['Void']['output']>;
  requestExperienceAccess?: Maybe<Scalars['Void']['output']>;
  requestFeedAccess: ExperienceFeed;
  requestPasswordReset?: Maybe<Scalars['Void']['output']>;
  requestScheduleAccess?: Maybe<Scalars['Void']['output']>;
  resendOrganizationInvite?: Maybe<Scalars['Void']['output']>;
  resetPassword: User;
  reviewEntriesJob: EntriesJob;
  revokeOAuthConnection?: Maybe<Scalars['Void']['output']>;
  revokeOrganizationInvite?: Maybe<Scalars['Void']['output']>;
  rsvp?: Maybe<Scalars['Void']['output']>;
  /** @deprecated Use saveEvents instead */
  saveEvent?: Maybe<Scalars['Void']['output']>;
  saveEvents?: Maybe<Scalars['Void']['output']>;
  scheduleOrganizationSeatPackRemoval?: Maybe<Scalars['Void']['output']>;
  sendEvent?: Maybe<Scalars['Void']['output']>;
  sendQuickEntry?: Maybe<Scalars['Void']['output']>;
  setExperienceOrganizationPermission?: Maybe<Scalars['Void']['output']>;
  setExperienceTheme: Experience;
  setExperienceVisibility: Experience;
  setInteractionSlot: InteractionSlot;
  setPreferredPlatform: User;
  setSchoolExperienceFundraiser?: Maybe<Scalars['Void']['output']>;
  setSchoolExperienceFundraiserImage: Scalars['String']['output'];
  setupChat: Chat;
  setupSchedule: Schedule;
  submitAvailability: AvailabilityResponse;
  submitMemberForm?: Maybe<Array<MemberFormFieldData>>;
  subscribeExperienceToCalendar: CalendarSubscription;
  subscribeToEvent?: Maybe<Scalars['Void']['output']>;
  subscribeToExperience?: Maybe<Scalars['Void']['output']>;
  suggestTextMessage: Scalars['String']['output'];
  toggleExperienceSave?: Maybe<Scalars['Void']['output']>;
  toggleFeedSecret?: Maybe<Scalars['Void']['output']>;
  toggleRsvp?: Maybe<Scalars['Void']['output']>;
  toggleScheduleSave?: Maybe<Scalars['Void']['output']>;
  transferExperienceOwnership?: Maybe<Scalars['Void']['output']>;
  transferOrganizationOwnership?: Maybe<Scalars['Void']['output']>;
  transferOwnership?: Maybe<Scalars['Void']['output']>;
  unfollowEntry?: Maybe<Scalars['Void']['output']>;
  unpublishSchoolExperience?: Maybe<Scalars['Void']['output']>;
  unsetInteractionSlot: Scalars['Void']['output'];
  unsubscribeExperienceFromCalendar?: Maybe<Scalars['Void']['output']>;
  unsubscribeFromEvent?: Maybe<Scalars['Void']['output']>;
  updateCategory: Category;
  updateCategorySortOrder?: Maybe<Scalars['Void']['output']>;
  updateDistrictRequest?: Maybe<Scalars['Void']['output']>;
  updateEntry: Entry;
  updateEntryMessage: EntryMessage;
  updateEvent: Event;
  updateEventMessage: EventMessage;
  updateEventMetadata: Event;
  updateExperience: Experience;
  updateExperienceCategory: ExperienceCategory;
  updateExperienceCategorySortOrder?: Maybe<Scalars['Void']['output']>;
  updateExperienceLabel: ExperienceLabel;
  updateExperienceLabelSortOrder?: Maybe<Scalars['Void']['output']>;
  updateExperiencePermission?: Maybe<Scalars['Void']['output']>;
  updateExperienceSlug?: Maybe<Scalars['Void']['output']>;
  updateFeedForExperience: ExperienceFeed;
  updateFeedForSchedule: Feed;
  updateLabel: Label;
  updateLabelSortOrder?: Maybe<Scalars['Void']['output']>;
  updateMember: Member;
  updateOrganization: Organization;
  updateOrganizationMember?: Maybe<Scalars['Void']['output']>;
  updateOrganizationMemberRole?: Maybe<Scalars['Void']['output']>;
  updatePrintableForChat?: Maybe<ChatPrintable>;
  updateProfile: User;
  updateSchedule: Schedule;
  updateSchedulePermission?: Maybe<Scalars['Void']['output']>;
  updateSnippet: Snippet;
  updateSnippetVisibility?: Maybe<Scalars['Void']['output']>;
  updateSourceForExperience: ExperienceFeed;
  uploadFileForChat: Scalars['String']['output'];
  uploadImageForEvent: Scalars['String']['output'];
  uploadImageForExperience: Scalars['String']['output'];
  uploadProfileImage: Scalars['String']['output'];
  verifyEmailLoginCode: EmailLoginCodeResult;
};

export type MutationAcceptOrganizationInviteArgs = {
  input: AcceptOrganizationInviteInput;
};

export type MutationAddExperiencePermissionsArgs = {
  input: AddExperiencePermissionsInput;
};

export type MutationAddFeedToExperienceArgs = {
  input: AddFeedToExperienceInput;
};

export type MutationAddMembersArgs = {
  members: Array<MemberInput>;
  scheduleId: Scalars['ID']['input'];
};

export type MutationAddOrganizationSeatPacksArgs = {
  input: AddOrganizationSeatPacksInput;
};

export type MutationAddSchedulePermissionsArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['ID']['input'];
  users: Array<UserPermissionInput>;
};

export type MutationAddSourceToExperienceArgs = {
  input: AddSourceToExperienceInput;
};

export type MutationAddSourceToScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
  syncCutoff?: InputMaybe<Scalars['Int']['input']>;
  uri: Scalars['String']['input'];
};

export type MutationAddTagToSchoolExperienceArgs = {
  input: AddTagToSchoolExperienceInput;
};

export type MutationAssignDistrictToDistrictRequestArgs = {
  input: AssignDistrictToDistrictRequestInput;
};

export type MutationCancelOrganizationSeatPackRemovalArgs = {
  input: CancelOrganizationSeatPackRemovalInput;
};

export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  updatedPassword: Scalars['String']['input'];
};

export type MutationCompleteMagicJobArgs = {
  input: CompleteMagicJobInput;
};

export type MutationConfigureInteractionAppArgs = {
  input: InteractionAppConfigInput;
};

export type MutationCopyExperienceArgs = {
  input: CopyExperienceInput;
};

export type MutationCopyPublicScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type MutationCopyScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type MutationCreateCanvaExportJobArgs = {
  input: CreateCanvaExportInput;
};

export type MutationCreateCategoryArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  color: Scalars['String']['input'];
  scheduleId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationCreateChatArgs = {
  input: CreateChatInput;
};

export type MutationCreateChildExperienceArgs = {
  input: CreateChildExperienceInput;
};

export type MutationCreateDistrictArgs = {
  input: CreateDistrictInput;
};

export type MutationCreateDistrictRequestArgs = {
  input: CreateDistrictRequestInput;
};

export type MutationCreateEntriesJobFromFileArgs = {
  base64File?: InputMaybe<Base64FileInput>;
  createDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['ID']['input'];
};

export type MutationCreateEntriesJobFromPromptArgs = {
  createDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  prompt: Scalars['String']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationCreateEntryArgs = {
  input: CreateEntryInput;
};

export type MutationCreateEntryAttachmentArgs = {
  entryId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationCreateEntryMessageArgs = {
  body: Scalars['String']['input'];
  deliveryTimeType: DeliveryTimeType;
  entryId: Scalars['ID']['input'];
  entryMessageId?: InputMaybe<Scalars['ID']['input']>;
  fixedDeliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  fixedTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  hybridDeliveryTime?: InputMaybe<Scalars['LocalTime']['input']>;
  hybridRelativeTime?: InputMaybe<HybridRelativeTime>;
  hybridTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  instance: Scalars['DateTime']['input'];
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  relativeTimeToEntryStart?: InputMaybe<Scalars['Int']['input']>;
  relativeTimeToEntryStartDirection?: InputMaybe<TimeDirection>;
  relativeTimeToEntryStartUnit?: InputMaybe<TimeUnit>;
  scheduleId: Scalars['ID']['input'];
  sendToEveryone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateEntryMessagesArgs = {
  entryId: Scalars['ID']['input'];
  messages: Array<EntryMessageInput>;
  scheduleId: Scalars['ID']['input'];
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationCreateEventMessageArgs = {
  input: CreateEventMessageInput;
};

export type MutationCreateEventsArgs = {
  input: CreateEventsInput;
};

export type MutationCreateExperienceArgs = {
  input: CreateExperienceInput;
};

export type MutationCreateExperienceCategoryArgs = {
  input: CreateExperienceCategoryInput;
};

export type MutationCreateExperienceLabelArgs = {
  input: CreateExperienceLabelInput;
};

export type MutationCreateLabelArgs = {
  labelId?: InputMaybe<Scalars['ID']['input']>;
  scheduleId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  type: LabelType;
};

export type MutationCreateMagicJobArgs = {
  input: CreateMagicJobInput;
};

export type MutationCreatePlannerFromPromptArgs = {
  input: CreatePlannerFromPromptInput;
};

export type MutationCreatePrintableForChatArgs = {
  input: CreatePrintableForChatInput;
};

export type MutationCreateQuickEntriesJobFromFileArgs = {
  base64File?: InputMaybe<Base64FileInput>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<QuickEntriesJobSource>;
  timeZone: Scalars['TimeZone']['input'];
  version?: InputMaybe<QuickEntriesJobVersion>;
};

export type MutationCreateQuickEntriesJobFromPromptArgs = {
  prompt: Scalars['String']['input'];
  source?: InputMaybe<QuickEntriesJobSource>;
  timeZone: Scalars['TimeZone']['input'];
  version?: InputMaybe<QuickEntriesJobVersion>;
};

export type MutationCreateScheduleArgs = {
  headerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerId?: InputMaybe<ScheduleHeaderId>;
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<ScheduleType>;
};

export type MutationCreateScheduleFromFeedArgs = {
  feedUrl: Scalars['String']['input'];
  syncCutoff?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateScheduleFromTemplateArgs = {
  templateId: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
};

export type MutationCreateSchoolExperienceArgs = {
  input: CreateSchoolExperienceInput;
};

export type MutationCreateShortTitlesArgs = {
  input: CreateShortTitlesInput;
};

export type MutationCreateSnippetArgs = {
  categories: Array<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  feeds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labels: Array<LabelIdInput>;
  name: Scalars['String']['input'];
  scheduleId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  whoLabels: Array<LabelIdInput>;
};

export type MutationDeleteAccountArgs = {
  confirmation: Scalars['String']['input'];
};

export type MutationDeleteCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationDeleteChildExperienceArgs = {
  input: DeleteChildExperienceInput;
};

export type MutationDeleteEntryArgs = {
  entryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationDeleteEntryMessageArgs = {
  entryMessageId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationDeleteEventArgs = {
  input: DeleteEventInput;
};

export type MutationDeleteEventMessageArgs = {
  input: DeleteEventMessageInput;
};

export type MutationDeleteEventsFromSchoolExperienceArgs = {
  input: DeleteEventsFromSchoolExperienceInput;
};

export type MutationDeleteExperienceArgs = {
  input: DeleteExperienceInput;
};

export type MutationDeleteExperienceCategoryArgs = {
  input: DeleteExperienceCategoryInput;
};

export type MutationDeleteExperienceLabelArgs = {
  input: DeleteExperienceLabelInput;
};

export type MutationDeleteFeedSecretArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLabelArgs = {
  labelId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationDeletePrintableForChatArgs = {
  input: DeletePrintableForChatInput;
};

export type MutationDeleteScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type MutationDeleteSnippetArgs = {
  scheduleId: Scalars['ID']['input'];
  snippetId: Scalars['ID']['input'];
};

export type MutationDisableExperienceTemplateArgs = {
  input: DisableExperienceTemplateInput;
};

export type MutationEditDistrictArgs = {
  input: EditDistrictInput;
};

export type MutationEnableExperienceTemplateArgs = {
  input: EnableExperienceTemplateInput;
};

export type MutationExportEventsArgs = {
  input: ExportEventsInput;
};

export type MutationExportQuickEntriesArgs = {
  attendees?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  calendarId: Scalars['String']['input'];
  integrationId: Scalars['ID']['input'];
  quickEntryIds: Array<Scalars['ID']['input']>;
};

export type MutationFlagNoSchoolEventsArgs = {
  input: FlagNoSchoolEventsInput;
};

export type MutationFollowEntryArgs = {
  entryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationGenerateFeedSecretArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type MutationImportChatArgs = {
  input: ImportChatInput;
};

export type MutationImportChatIntoScheduleArgs = {
  input: ImportChatIntoScheduleInput;
};

export type MutationImportMagicJobArgs = {
  input: ImportMagicJobInput;
};

export type MutationImportMagicJobIntoScheduleArgs = {
  input: ImportMagicJobIntoScheduleInput;
};

export type MutationInstallInteractionAppArgs = {
  input: InstallInteractionAppInput;
};

export type MutationInviteOrganizationMembersArgs = {
  input: InviteOrganizationMembersInput;
};

export type MutationLeaveExperienceArgs = {
  input: LeaveExperienceInput;
};

export type MutationLeaveScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type MutationLoginArgs = {
  email: Scalars['LowercaseString']['input'];
  password: Scalars['String']['input'];
};

export type MutationMoveExperienceToOrganizationArgs = {
  input: MoveExperienceToOrganizationInput;
};

export type MutationNotifyOwnerArgs = {
  input: NotifyOwnerInput;
};

export type MutationPublishJobEntriesArgs = {
  entriesJobId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationPublishSchoolExperienceArgs = {
  input: PublishSchoolExperienceInput;
};

export type MutationQaSchoolExperienceArgs = {
  input: QaSchoolExperienceInput;
};

export type MutationRateMagicJobArgs = {
  input: RateMagicJobInput;
};

export type MutationRefreshFeedArgs = {
  feedId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationRefreshSourceForExperienceArgs = {
  input: RefreshSourceForExperienceInput;
};

export type MutationRegisterArgs = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['LowercaseString']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
};

export type MutationRemoveEntryAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
  entryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationRemoveEventArgs = {
  input: RemoveEventInput;
};

export type MutationRemoveEventExportsArgs = {
  input: RemoveEventExportsInput;
};

export type MutationRemoveExperienceOrganizationPermissionArgs = {
  input: RemoveExperienceOrganizationPermissionInput;
};

export type MutationRemoveExperiencePermissionArgs = {
  input: RemoveExperiencePermissionInput;
};

export type MutationRemoveFeedFromExperienceArgs = {
  input: RemoveFeedFromExperienceInput;
};

export type MutationRemoveFeedFromScheduleArgs = {
  feedId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationRemoveImageForEventArgs = {
  input: RemoveImageForEventInput;
};

export type MutationRemoveImageForExperienceArgs = {
  input: RemoveImageForExperienceInput;
};

export type MutationRemoveMemberArgs = {
  memberId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationRemoveOrganizationMemberArgs = {
  input: RemoveOrganizationMemberInput;
};

export type MutationRemoveSchedulePermissionArgs = {
  scheduleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveSchoolExperienceFundraiserImageArgs = {
  input: RemoveSchoolExperienceFundraiserImageInput;
};

export type MutationRemoveSourceFromExperienceArgs = {
  input: RemoveSourceFromExperienceInput;
};

export type MutationRemoveTagFromSchoolExperienceArgs = {
  input: RemoveTagFromSchoolExperienceInput;
};

export type MutationRenameLibraryItemArgs = {
  input: RenameLibraryItemInput;
};

export type MutationRepeatMagicJobArgs = {
  input: RepeatMagicJobInput;
};

export type MutationRequestAccessArgs = {
  input: RequestAccessInput;
};

export type MutationRequestEmailLoginCodeArgs = {
  email: Scalars['LowercaseString']['input'];
};

export type MutationRequestExperienceAccessArgs = {
  input: RequestExperienceAccessInput;
};

export type MutationRequestFeedAccessArgs = {
  input: RequestFeedAccessInput;
};

export type MutationRequestPasswordResetArgs = {
  email: Scalars['LowercaseString']['input'];
};

export type MutationRequestScheduleAccessArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type MutationResendOrganizationInviteArgs = {
  input: ResendOrganizationInviteInput;
};

export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationReviewEntriesJobArgs = {
  entriesJobId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationRevokeOAuthConnectionArgs = {
  clientId: Scalars['String']['input'];
};

export type MutationRevokeOrganizationInviteArgs = {
  input: RevokeOrganizationInviteInput;
};

export type MutationRsvpArgs = {
  entryId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['ID']['input'];
  status?: InputMaybe<AttendeeStatus>;
};

export type MutationSaveEventArgs = {
  input: SaveEventInput;
};

export type MutationSaveEventsArgs = {
  input: SaveEventsInput;
};

export type MutationScheduleOrganizationSeatPackRemovalArgs = {
  input: ScheduleOrganizationSeatPackRemovalInput;
};

export type MutationSendEventArgs = {
  input: SendEventInput;
};

export type MutationSendQuickEntryArgs = {
  email: Scalars['LowercaseString']['input'];
  quickEntriesJobId?: InputMaybe<Scalars['ID']['input']>;
  quickEntryId: Scalars['ID']['input'];
};

export type MutationSetExperienceOrganizationPermissionArgs = {
  input: SetExperienceOrganizationPermissionInput;
};

export type MutationSetExperienceThemeArgs = {
  input: SetExperienceThemeInput;
};

export type MutationSetExperienceVisibilityArgs = {
  input: SetExperienceVisibilityInput;
};

export type MutationSetInteractionSlotArgs = {
  input: SetInteractionSlotInput;
};

export type MutationSetPreferredPlatformArgs = {
  preferredPlatform?: InputMaybe<PlatformTypes>;
};

export type MutationSetSchoolExperienceFundraiserArgs = {
  input: SetSchoolExperienceFundraiserInput;
};

export type MutationSetSchoolExperienceFundraiserImageArgs = {
  input: SetSchoolExperienceFundraiserImageInput;
};

export type MutationSetupChatArgs = {
  input: SetupChatInput;
};

export type MutationSetupScheduleArgs = {
  categories?: InputMaybe<Array<CategoryInput>>;
  labels?: InputMaybe<Array<LabelInput>>;
  members?: InputMaybe<Array<MemberInput>>;
  scheduleId: Scalars['ID']['input'];
  whoLabels?: InputMaybe<Array<LabelInput>>;
};

export type MutationSubmitAvailabilityArgs = {
  response: AvailabilityResponseInput;
  scheduleId: Scalars['ID']['input'];
};

export type MutationSubmitMemberFormArgs = {
  formData: Array<MemberFormFieldDataInput>;
  scheduleId: Scalars['ID']['input'];
};

export type MutationSubscribeExperienceToCalendarArgs = {
  input: SubscribeExperienceToCalendarInput;
};

export type MutationSubscribeToEventArgs = {
  input: SubscribeToEventInput;
};

export type MutationSubscribeToExperienceArgs = {
  input: SubscribeToExperienceInput;
};

export type MutationSuggestTextMessageArgs = {
  input: SuggestTextMessageInput;
};

export type MutationToggleExperienceSaveArgs = {
  input: ToggleExperienceSaveInput;
};

export type MutationToggleFeedSecretArgs = {
  enabled: Scalars['Boolean']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationToggleRsvpArgs = {
  enabled: Scalars['Boolean']['input'];
  entryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationToggleScheduleSaveArgs = {
  saved: Scalars['Boolean']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationTransferExperienceOwnershipArgs = {
  input: TransferExperienceOwnershipInput;
};

export type MutationTransferOrganizationOwnershipArgs = {
  input: TransferOrganizationOwnershipInput;
};

export type MutationTransferOwnershipArgs = {
  scheduleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationUnfollowEntryArgs = {
  entryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationUnpublishSchoolExperienceArgs = {
  input: UnpublishSchoolExperienceInput;
};

export type MutationUnsetInteractionSlotArgs = {
  input: UnsetInteractionSlotInput;
};

export type MutationUnsubscribeExperienceFromCalendarArgs = {
  input: UnsubscribeExperienceFromCalendarInput;
};

export type MutationUnsubscribeFromEventArgs = {
  input: UnsubscribeFromEventInput;
};

export type MutationUpdateCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCategorySortOrderArgs = {
  categories: Array<CategorySortOrderInput>;
  scheduleId: Scalars['ID']['input'];
};

export type MutationUpdateDistrictRequestArgs = {
  input: UpdateDistrictRequestInput;
};

export type MutationUpdateEntryArgs = {
  input: UpdateEntryInput;
};

export type MutationUpdateEntryMessageArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeType: DeliveryTimeType;
  entryMessageId: Scalars['ID']['input'];
  fixedDeliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  fixedTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  hybridDeliveryTime?: InputMaybe<Scalars['LocalTime']['input']>;
  hybridRelativeTime?: InputMaybe<HybridRelativeTime>;
  hybridTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  instance: Scalars['DateTime']['input'];
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  relativeTimeToEntryStart?: InputMaybe<Scalars['Int']['input']>;
  relativeTimeToEntryStartDirection?: InputMaybe<TimeDirection>;
  relativeTimeToEntryStartUnit?: InputMaybe<TimeUnit>;
  scheduleId: Scalars['ID']['input'];
  sendToEveryone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};

export type MutationUpdateEventMessageArgs = {
  input: UpdateEventMessageInput;
};

export type MutationUpdateEventMetadataArgs = {
  input: UpdateEventMetadataInput;
};

export type MutationUpdateExperienceArgs = {
  input: UpdateExperienceInput;
};

export type MutationUpdateExperienceCategoryArgs = {
  input: UpdateExperienceCategoryInput;
};

export type MutationUpdateExperienceCategorySortOrderArgs = {
  input: UpdateExperienceCategorySortOrderInput;
};

export type MutationUpdateExperienceLabelArgs = {
  input: UpdateExperienceLabelInput;
};

export type MutationUpdateExperienceLabelSortOrderArgs = {
  input: UpdateExperienceLabelSortOrderInput;
};

export type MutationUpdateExperiencePermissionArgs = {
  input: UpdateExperiencePermissionInput;
};

export type MutationUpdateExperienceSlugArgs = {
  input: UpdateExperienceSlugInput;
};

export type MutationUpdateFeedForExperienceArgs = {
  input: UpdateFeedForExperienceInput;
};

export type MutationUpdateFeedForScheduleArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  feedId: Scalars['ID']['input'];
  labels?: InputMaybe<Array<LabelIdInput>>;
  scheduleId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  whoLabels?: InputMaybe<Array<LabelIdInput>>;
};

export type MutationUpdateLabelArgs = {
  labelId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationUpdateLabelSortOrderArgs = {
  labels: Array<LabelSortOrderInput>;
  scheduleId: Scalars['ID']['input'];
};

export type MutationUpdateMemberArgs = {
  memberId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  scheduleId: Scalars['ID']['input'];
};

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

export type MutationUpdateOrganizationMemberArgs = {
  input: UpdateOrganizationMemberInput;
};

export type MutationUpdateOrganizationMemberRoleArgs = {
  input: UpdateOrganizationMemberRoleInput;
};

export type MutationUpdatePrintableForChatArgs = {
  input: UpdatePrintableForChatInput;
};

export type MutationUpdateProfileArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateScheduleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  headerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerId?: InputMaybe<ScheduleHeaderId>;
  headerType?: InputMaybe<ScheduleHeaderType>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  rsvpSettings?: InputMaybe<RsvpSettingsInput>;
  scheduleId: Scalars['ID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  socialSharingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Array<InputMaybe<ScheduleViewInput>>>;
};

export type MutationUpdateSchedulePermissionArgs = {
  role: Role;
  scheduleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationUpdateSnippetArgs = {
  categories: Array<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  feeds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labels: Array<LabelIdInput>;
  name: Scalars['String']['input'];
  scheduleId: Scalars['ID']['input'];
  snippetId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  whoLabels: Array<LabelIdInput>;
};

export type MutationUpdateSnippetVisibilityArgs = {
  scheduleId: Scalars['ID']['input'];
  snippetId: Scalars['ID']['input'];
  visibility: Visibility;
};

export type MutationUpdateSourceForExperienceArgs = {
  input: UpdateSourceForExperienceInput;
};

export type MutationUploadFileForChatArgs = {
  input: UploadFileForChatInput;
};

export type MutationUploadImageForEventArgs = {
  input: UploadImageForEventInput;
};

export type MutationUploadImageForExperienceArgs = {
  input: UploadImageForExperienceInput;
};

export type MutationUploadProfileImageArgs = {
  image: Scalars['Upload']['input'];
};

export type MutationVerifyEmailLoginCodeArgs = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  email: Scalars['LowercaseString']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
};

export type NotifyOwnerInput = {
  experienceId: Scalars['ID']['input'];
  type: NotifyOwnerType;
};

export enum NotifyOwnerType {
  Upgrade = 'UPGRADE',
}

export type OAuthConnection = {
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  grantedAt: Scalars['DateTime']['output'];
  scopes: Array<Scalars['String']['output']>;
};

export type Organization = {
  createdAt: Scalars['DateTime']['output'];
  effectiveTier: UserTier;
  id: Scalars['ID']['output'];
  inheritedSeatTier: UserTier;
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pendingSeatLimit?: Maybe<Scalars['Int']['output']>;
  pendingSeatPacks?: Maybe<Scalars['Int']['output']>;
  role: OrganizationRole;
  seatLimit?: Maybe<Scalars['Int']['output']>;
  seatPacks?: Maybe<Scalars['Int']['output']>;
  seatTier: UserTier;
  subscriptionCancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  subscriptionCurrentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  subscriptionSource?: Maybe<SubscriptionSource>;
  subscriptionStatus?: Maybe<UserSubscriptionStatus>;
  type: OrganizationType;
};

export type OrganizationInvite = {
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedByName?: Maybe<Scalars['String']['output']>;
  isExpired: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: OrganizationRole;
  status: OrganizationInviteStatus;
};

export enum OrganizationInviteStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Revoked = 'REVOKED',
}

export type OrganizationMember = {
  createdAt: Scalars['DateTime']['output'];
  memberName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  role: OrganizationRole;
  user: PublicUser;
};

export type OrganizationMemberInput = {
  email: Scalars['LowercaseString']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  role: OrganizationRole;
};

export enum OrganizationRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
}

export enum OrganizationType {
  Business = 'BUSINESS',
  Family = 'FAMILY',
  Personal = 'PERSONAL',
}

export enum OwnerPermissions {
  AddToCalendar = 'ADD_TO_CALENDAR',
  EntryCreate = 'ENTRY_CREATE',
  EntryDelete = 'ENTRY_DELETE',
  EntryUpdate = 'ENTRY_UPDATE',
  Messages = 'MESSAGES',
  PermissionsModify = 'PERMISSIONS_MODIFY',
  Rsvp = 'RSVP',
  ScheduleCopy = 'SCHEDULE_COPY',
  ScheduleDelete = 'SCHEDULE_DELETE',
  ScheduleExport = 'SCHEDULE_EXPORT',
  ScheduleImport = 'SCHEDULE_IMPORT',
  ScheduleModifySettings = 'SCHEDULE_MODIFY_SETTINGS',
  ScheduleRename = 'SCHEDULE_RENAME',
  ScheduleView = 'SCHEDULE_VIEW',
  SnippetEdit = 'SNIPPET_EDIT',
  SnippetView = 'SNIPPET_VIEW',
}

export type PdfFrom = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};

export type PendingInvitation = {
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedByName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  organizationType: OrganizationType;
  role: OrganizationRole;
};

export type PlannerLicense = {
  amountPaid: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  experienceId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  tier: PlannerTier;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlannerTier {
  DigitalShared = 'DIGITAL_SHARED',
  PrintableMulti = 'PRINTABLE_MULTI',
  PrintableSingle = 'PRINTABLE_SINGLE',
}

export type PlannerTierConfig = {
  key: PlannerTier;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export enum PlatformTypes {
  AgendaHero = 'AGENDA_HERO',
  AppleIcs = 'APPLE_ICS',
  Email = 'EMAIL',
  GoogleIntegration = 'GOOGLE_INTEGRATION',
  GoogleLink = 'GOOGLE_LINK',
  OfficeLink = 'OFFICE_LINK',
  OtherIcs = 'OTHER_ICS',
  OutlookIntegration = 'OUTLOOK_INTEGRATION',
  OutlookLink = 'OUTLOOK_LINK',
}

export type PreviewExperiencePermissionRemovalInput = {
  experienceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type PreviewMagicExperienceInput = {
  magicJobId: Scalars['String']['input'];
};

export enum PrintableBackground {
  Cloud_1 = 'cloud_1',
  Cloud_2 = 'cloud_2',
  Cloud_3 = 'cloud_3',
  Color_1 = 'color_1',
  Color_2 = 'color_2',
  Kawaii_1 = 'kawaii_1',
  Kawaii_2 = 'kawaii_2',
  Kawaii_3 = 'kawaii_3',
  None = 'none',
  Winter_1 = 'winter_1',
  Winter_2 = 'winter_2',
  Winter_3 = 'winter_3',
}

export type PrintableBackgroundInfo = {
  id: PrintableBackground;
  name: Scalars['String']['output'];
  swatchUrl?: Maybe<Scalars['String']['output']>;
};

export type PrintableConfig = {
  background: PrintableBackground;
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  isEmojiEnabled: Scalars['Boolean']['output'];
  isEndTimeEnabled: Scalars['Boolean']['output'];
  isLocationEnabled: Scalars['Boolean']['output'];
  isStartTimeEnabled: Scalars['Boolean']['output'];
  isYearEnabled: Scalars['Boolean']['output'];
};

export type PrintableConfigInfo = {
  backgrounds: Array<PrintableBackgroundInfo>;
};

export type PrintableConfigInput = {
  background: PrintableBackground;
  isEmojiEnabled: Scalars['Boolean']['input'];
  isEndTimeEnabled: Scalars['Boolean']['input'];
  isLocationEnabled: Scalars['Boolean']['input'];
  isStartTimeEnabled: Scalars['Boolean']['input'];
  isYearEnabled: Scalars['Boolean']['input'];
};

export enum PublicPermissions {
  AddToCalendar = 'ADD_TO_CALENDAR',
}

export type PublicUser = {
  avatar: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['LowercaseString']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type PublishSchoolExperienceInput = {
  experienceId: Scalars['ID']['input'];
};

export enum QaConfidenceScore {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum QaPdfComplexity {
  Complex = 'COMPLEX',
  Moderate = 'MODERATE',
  Simple = 'SIMPLE',
}

export type QaSchoolExperienceInput = {
  experienceId: Scalars['ID']['input'];
  skipRulesValidation?: InputMaybe<Scalars['Boolean']['input']>;
  useAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum QaVerdict {
  Fail = 'FAIL',
  Flagged = 'FLAGGED',
  Pass = 'PASS',
}

export type Query = {
  _empty?: Maybe<Scalars['String']['output']>;
  accountDeletionPreview: AccountDeletionPreview;
  checkSlugAvailability: Scalars['Boolean']['output'];
  findDistricts: FindDistrictsResult;
  getAppConfig: AppConfig;
  getAuthAction: AuthAction;
  getAvailabilityResponses: Array<AvailabilityResponse>;
  getCanvaDesigns: ListCanvaDesignResult;
  getCanvaExportJob: CanvaExportJob;
  getChat: Chat;
  getChatPrintableConfigInfo: ChatPrintableConfigInfo;
  getCustomArtifact?: Maybe<CustomArtifact>;
  getDistrictRequests: GetDistrictRequestsResult;
  getEntriesJobForSchedule: EntriesJob;
  getEntriesJobsForSchedule: Array<EntriesJob>;
  getEntry: Entry;
  getEntryMessages: Array<EntryMessage>;
  getEventExports: Array<EventExport>;
  getEventForExperience: Event;
  getEventMessageRecipients: Array<EventMessageRecipient>;
  getEventMessages: Array<EventMessage>;
  getExperience: Experience;
  getExperienceChildConfigs: Array<ExperienceChildConfigInfo>;
  getExperiencePermissions: UserPermissions;
  getExperienceThemes: Array<ExperienceTheme>;
  getExperienceUpdateRequesters: Array<Scalars['String']['output']>;
  getFeedForSchedule: Feed;
  getIcsFeeds: Array<FeedSummary>;
  getIntegrations: Array<Integration>;
  getInternalFeeds: Array<FeedSummary>;
  getLayout: LayoutDefinition;
  getLibrary: Array<LibraryItem>;
  getMagicJob: MagicJob;
  getMemberForm: MemberForm;
  getOAuthConnections: Array<OAuthConnection>;
  getOrganizationInvites: Array<OrganizationInvite>;
  getOrganizationMembers: Array<OrganizationMember>;
  getOrganizations: Array<Organization>;
  getPendingInvitations: Array<PendingInvitation>;
  getPrintableConfigInfo: PrintableConfigInfo;
  getProfile: User;
  getPublicTemplates: Array<ExperienceTemplate>;
  getPublishedChildExperience: Experience;
  getPublishedCustomArtifact?: Maybe<CustomArtifact>;
  getPublishedExperience: Experience;
  /** @deprecated Potentially used by old mobile app versions */
  getQuickEntriesJob: QuickEntriesJob;
  getQuickEntriesPage: QuickEntriesPage;
  getSchedule: Schedule;
  getScheduleHeaderImages: Array<ScheduleHeaderImage>;
  getScheduleTemplates: Array<ScheduleTemplate>;
  getSchedules: Array<Schedule>;
  getSnippet: Snippet;
  getSnippets: Array<Snippet>;
  getTemplateAccountExperiences: Array<TemplateAccountExperience>;
  previewExperiencePermissionRemoval: ExperiencePermissionRemovalPreview;
  previewMagicExperience: Experience;
  verifyPasswordReset?: Maybe<Scalars['Void']['output']>;
  viewerFeedDestinations: Array<ExperienceRef>;
};

export type QueryCheckSlugAvailabilityArgs = {
  input: CheckSlugAvailabilityInput;
};

export type QueryFindDistrictsArgs = {
  input: FindDistrictsInput;
};

export type QueryGetAuthActionArgs = {
  email: Scalars['LowercaseString']['input'];
};

export type QueryGetAvailabilityResponsesArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetCanvaDesignsArgs = {
  input: ListCanvaDesignInput;
};

export type QueryGetCanvaExportJobArgs = {
  input: GetCanvaExportJobInput;
};

export type QueryGetChatArgs = {
  input: GetChatInput;
};

export type QueryGetCustomArtifactArgs = {
  input: GetCustomArtifactInput;
};

export type QueryGetDistrictRequestsArgs = {
  input: GetDistrictRequestsInput;
};

export type QueryGetEntriesJobForScheduleArgs = {
  entriesJobId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetEntriesJobsForScheduleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scheduleId: Scalars['ID']['input'];
  statuses?: InputMaybe<Array<JobStatus>>;
};

export type QueryGetEntryArgs = {
  entryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetEntryMessagesArgs = {
  scheduleId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<SortDirection>;
};

export type QueryGetEventExportsArgs = {
  input: GetEventExportsInput;
};

export type QueryGetEventForExperienceArgs = {
  input: GetEventForExperienceInput;
};

export type QueryGetEventMessageRecipientsArgs = {
  input: GetEventMessageRecipientsInput;
};

export type QueryGetEventMessagesArgs = {
  input: GetEventMessagesInput;
};

export type QueryGetExperienceArgs = {
  input: GetExperienceInput;
};

export type QueryGetExperiencePermissionsArgs = {
  input: GetExperiencePermissionsInput;
};

export type QueryGetExperienceThemesArgs = {
  input: GetExperienceThemesInput;
};

export type QueryGetExperienceUpdateRequestersArgs = {
  input: GetExperienceUpdateRequestersInput;
};

export type QueryGetFeedForScheduleArgs = {
  feedId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetIcsFeedsArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetInternalFeedsArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetLayoutArgs = {
  input: GetLayoutInput;
};

export type QueryGetLibraryArgs = {
  input?: InputMaybe<GetLibraryInput>;
};

export type QueryGetMagicJobArgs = {
  input: GetMagicJobInput;
};

export type QueryGetMemberFormArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetOrganizationInvitesArgs = {
  input: GetOrganizationInvitesInput;
};

export type QueryGetOrganizationMembersArgs = {
  input: GetOrganizationMembersInput;
};

export type QueryGetPublishedChildExperienceArgs = {
  input: GetPublishedChildExperienceInput;
};

export type QueryGetPublishedCustomArtifactArgs = {
  input: GetPublishedChildExperienceInput;
};

export type QueryGetPublishedExperienceArgs = {
  input: GetPublishedExperienceInput;
};

export type QueryGetQuickEntriesJobArgs = {
  quickEntriesJobId: Scalars['ID']['input'];
};

export type QueryGetQuickEntriesPageArgs = {
  by: QuickEntriesPageBy;
};

export type QueryGetScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type QueryGetSnippetArgs = {
  snippetId: Scalars['ID']['input'];
};

export type QueryGetSnippetsArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type QueryPreviewExperiencePermissionRemovalArgs = {
  input: PreviewExperiencePermissionRemovalInput;
};

export type QueryPreviewMagicExperienceArgs = {
  input: PreviewMagicExperienceInput;
};

export type QueryVerifyPasswordResetArgs = {
  token: Scalars['String']['input'];
};

export type QueryViewerFeedDestinationsArgs = {
  input: ViewerFeedDestinationsInput;
};

export type QuickEntriesJob = {
  convertedFromMagicJob?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  file?: Maybe<QuickEntriesJobFile>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<QuickEntriesJobMetadata>;
  prompt?: Maybe<Scalars['String']['output']>;
  quickEntries: Array<QuickEntry>;
  scheduleId?: Maybe<Scalars['ID']['output']>;
  source: QuickEntriesJobSource;
  sourcePrompt?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
  timeZone: Scalars['TimeZone']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: QuickEntriesJobType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuickEntriesJobFile = {
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  mimetype: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type QuickEntriesJobMetadata = {
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum QuickEntriesJobSource {
  Android = 'ANDROID',
  App = 'APP',
  Canva = 'CANVA',
  ChromeExtension = 'CHROME_EXTENSION',
  Email = 'EMAIL',
  Ios = 'IOS',
  Web = 'WEB',
}

export enum QuickEntriesJobType {
  File = 'FILE',
  Prompt = 'PROMPT',
}

export enum QuickEntriesJobVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export type QuickEntriesPage = {
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  quickEntries: Array<QuickEntry>;
  socialSharingEnabled: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type QuickEntriesPageBy = {
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
  scheduleSlug?: InputMaybe<Scalars['String']['input']>;
};

export type QuickEntry = {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationWithPlace?: Maybe<Location>;
  recurrences: Array<Recurrence>;
  timeZone: Scalars['TimeZone']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuickEntryExport = {
  calendarId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entryId?: Maybe<Scalars['ID']['output']>;
  externalId: Scalars['String']['output'];
  externalLink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationId?: Maybe<Scalars['ID']['output']>;
  quickEntryId?: Maybe<Scalars['ID']['output']>;
  userId: Scalars['ID']['output'];
};

export type RateMagicJobInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  logRocketUrl?: InputMaybe<Scalars['String']['input']>;
  magicJobId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
};

export type Recurrence = {
  endDate: Scalars['DateTime']['output'];
  endDay?: Maybe<Scalars['DateOnly']['output']>;
  isOnDay: Scalars['Boolean']['output'];
  localEndTime?: Maybe<Scalars['LocalTime']['output']>;
  localOffsetName?: Maybe<Scalars['String']['output']>;
  localStartTime?: Maybe<Scalars['LocalTime']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  startDay?: Maybe<Scalars['DateOnly']['output']>;
};

export type RecurrenceInput = {
  endDate: Scalars['DateTime']['input'];
  isOnDay: Scalars['Boolean']['input'];
  rule?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type RefreshSourceForExperienceInput = {
  experienceId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};

export type RemoveEventExportsInput = {
  calendarId: Scalars['String']['input'];
  eventIds: Array<Scalars['ID']['input']>;
  integrationId: Scalars['ID']['input'];
};

export type RemoveEventInput = {
  eventId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
};

export type RemoveExperienceOrganizationPermissionInput = {
  experienceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type RemoveExperiencePermissionInput = {
  experienceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveFeedFromExperienceInput = {
  experienceId: Scalars['ID']['input'];
  feedId: Scalars['ID']['input'];
};

export type RemoveImageForEventInput = {
  eventId: Scalars['ID']['input'];
  for: EventFor;
};

export type RemoveImageForExperienceInput = {
  experienceId: Scalars['ID']['input'];
  type: ExperienceImageTypes;
};

export type RemoveOrganizationMemberInput = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveSchoolExperienceFundraiserImageInput = {
  experienceId: Scalars['ID']['input'];
};

export type RemoveSourceFromExperienceInput = {
  experienceId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};

export type RemoveTagFromSchoolExperienceInput = {
  experienceId: Scalars['ID']['input'];
  tag: SchoolExperienceTag;
};

export type RenameLibraryItemInput = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type RenameLibraryItemPayload = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type RepeatMagicJobInput = {
  chatId: Scalars['ID']['input'];
  magicJobId: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
  toolCallId: Scalars['String']['input'];
};

export type RequestAccessInput = {
  feature: Feature;
};

export type RequestExperienceAccessInput = {
  experienceId: Scalars['ID']['input'];
};

export type RequestFeedAccessInput = {
  experienceId: Scalars['ID']['input'];
  feedId: Scalars['ID']['input'];
};

export type ResendOrganizationInviteInput = {
  inviteId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type RevokeOrganizationInviteInput = {
  inviteId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum Role {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Public = 'PUBLIC',
  Viewer = 'VIEWER',
}

export type RolePermissions = {
  editor: Array<EditorPermissions>;
  owner: Array<OwnerPermissions>;
  public: Array<PublicPermissions>;
  viewer: Array<ViewerPermissions>;
};

export type RsvpInfo = {
  notes?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AttendeeStatus>;
};

export type RsvpSettings = {
  noLabel?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  yesLabel?: Maybe<Scalars['String']['output']>;
};

export type RsvpSettingsInput = {
  noLabel?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  yesLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SaveEventInput = {
  eventId: Scalars['ID']['input'];
  fromExperienceId: Scalars['ID']['input'];
  toExperienceId: Scalars['ID']['input'];
};

export type SaveEventsInput = {
  eventIds: Array<Scalars['ID']['input']>;
  fromExperienceId: Scalars['ID']['input'];
  toExperienceId: Scalars['ID']['input'];
};

export type SaveQuickEntriesJobInput = {
  id: Scalars['ID']['input'];
};

export type Schedule = {
  activeUsers: Array<Scalars['ID']['output']>;
  categories: Array<Category>;
  createdAt: Scalars['DateTime']['output'];
  cta?: Maybe<ScheduleCta>;
  description?: Maybe<Scalars['String']['output']>;
  entries: Array<Entry>;
  feedSecret: FeedSecret;
  feeds: Array<FeedSummary>;
  firstEntryStartDate?: Maybe<Scalars['DateTime']['output']>;
  hasBeenSetup: Scalars['Boolean']['output'];
  hasEntries: Scalars['Boolean']['output'];
  header: ScheduleHeader;
  id: Scalars['ID']['output'];
  isCopyable: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  isSaved: Scalars['Boolean']['output'];
  labels: Array<Label>;
  limits: ScheduleLimits;
  memberForm?: Maybe<MemberForm>;
  members?: Maybe<Array<Member>>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  permissions?: Maybe<UserPermissions>;
  role: Role;
  rsvpSettings?: Maybe<RsvpSettings>;
  selfMemberFormSubmission?: Maybe<Array<MemberFormFieldData>>;
  slug?: Maybe<Scalars['String']['output']>;
  socialSharingEnabled: Scalars['Boolean']['output'];
  timeZone: Scalars['TimeZone']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: ScheduleType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  views: Array<ScheduleView>;
  whoLabels: Array<Label>;
};

export type ScheduleEntriesArgs = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  feeds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  snippets?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  whoLabels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ScheduleCta = {
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ScheduleHeader = {
  enabled: Scalars['Boolean']['output'];
  id?: Maybe<ScheduleHeaderId>;
  imageBaseUrl?: Maybe<Scalars['String']['output']>;
  type: ScheduleHeaderType;
};

export enum ScheduleHeaderId {
  Acting_1 = 'ACTING_1',
  Agendahero_1 = 'AGENDAHERO_1',
  Archery_1 = 'ARCHERY_1',
  Astronomy_1 = 'ASTRONOMY_1',
  Baking_1 = 'BAKING_1',
  Baseball_1 = 'BASEBALL_1',
  Basketball_1 = 'BASKETBALL_1',
  Beach_1 = 'BEACH_1',
  BeachVolleyball_1 = 'BEACH_VOLLEYBALL_1',
  Billiards_1 = 'BILLIARDS_1',
  Biology_1 = 'BIOLOGY_1',
  Birds_1 = 'BIRDS_1',
  Birthday_1 = 'BIRTHDAY_1',
  Books_1 = 'BOOKS_1',
  Bowling_1 = 'BOWLING_1',
  Boxing_1 = 'BOXING_1',
  Business_1 = 'BUSINESS_1',
  Camping_1 = 'CAMPING_1',
  Camping_2 = 'CAMPING_2',
  Canyon_1 = 'CANYON_1',
  Cards_1 = 'CARDS_1',
  Carpool_1 = 'CARPOOL_1',
  Cat_1 = 'CAT_1',
  Chemistry_1 = 'CHEMISTRY_1',
  ChessClub_1 = 'CHESS_CLUB_1',
  Cycling_1 = 'CYCLING_1',
  Dancing_1 = 'DANCING_1',
  DebateTeam_1 = 'DEBATE_TEAM_1',
  Doctor_1 = 'DOCTOR_1',
  Dog_1 = 'DOG_1',
  Dog_2 = 'DOG_2',
  Electronics_1 = 'ELECTRONICS_1',
  Fall_1 = 'FALL_1',
  Family_1 = 'FAMILY_1',
  FieldHockey_1 = 'FIELD_HOCKEY_1',
  Fishing_1 = 'FISHING_1',
  Fish_1 = 'FISH_1',
  Football_1 = 'FOOTBALL_1',
  Garbage_1 = 'GARBAGE_1',
  Gardening_1 = 'GARDENING_1',
  Gliding_1 = 'GLIDING_1',
  Golf_1 = 'GOLF_1',
  Golf_2 = 'GOLF_2',
  Graduation_1 = 'GRADUATION_1',
  Groceries_1 = 'GROCERIES_1',
  Gymnastics_1 = 'GYMNASTICS_1',
  Hamster_1 = 'HAMSTER_1',
  HappyBikeStroll_1 = 'HAPPY_BIKE_STROLL_1',
  HighDive_1 = 'HIGH_DIVE_1',
  Hiking_1 = 'HIKING_1',
  Hiking_2 = 'HIKING_2',
  Homework_1 = 'HOMEWORK_1',
  Horses_1 = 'HORSES_1',
  IceHockey_1 = 'ICE_HOCKEY_1',
  IceSkating_1 = 'ICE_SKATING_1',
  Instruments_1 = 'INSTRUMENTS_1',
  Karate_1 = 'KARATE_1',
  Lacrosse_1 = 'LACROSSE_1',
  Lake_1 = 'LAKE_1',
  LawClub_1 = 'LAW_CLUB_1',
  Lion_1 = 'LION_1',
  London_1 = 'LONDON_1',
  LosAngeles_1 = 'LOS_ANGELES_1',
  Meeting_1 = 'MEETING_1',
  NewYork_1 = 'NEW_YORK_1',
  Paris_1 = 'PARIS_1',
  Park_1 = 'PARK_1',
  Pets_1 = 'PETS_1',
  Photography_1 = 'PHOTOGRAPHY_1',
  Piano_1 = 'PIANO_1',
  PingPong_1 = 'PING_PONG_1',
  PreSchool_1 = 'PRE_SCHOOL_1',
  PreSchool_2 = 'PRE_SCHOOL_2',
  RoadTrip_1 = 'ROAD_TRIP_1',
  RoboticsClub_1 = 'ROBOTICS_CLUB_1',
  RomeColosseum_1 = 'ROME_COLOSSEUM_1',
  Sailing_1 = 'SAILING_1',
  SanFrancisco_1 = 'SAN_FRANCISCO_1',
  SanFrancisco_2 = 'SAN_FRANCISCO_2',
  School_1 = 'SCHOOL_1',
  Scuba_1 = 'SCUBA_1',
  Singing_1 = 'SINGING_1',
  Skateboarding_1 = 'SKATEBOARDING_1',
  Skiing_1 = 'SKIING_1',
  SkyDiving_1 = 'SKY_DIVING_1',
  Snowboarding_1 = 'SNOWBOARDING_1',
  Soccer_1 = 'SOCCER_1',
  Soccer_2 = 'SOCCER_2',
  Spring_1 = 'SPRING_1',
  Summer_1 = 'SUMMER_1',
  Surfing_1 = 'SURFING_1',
  Surfing_2 = 'SURFING_2',
  Swimming_1 = 'SWIMMING_1',
  Sydney_1 = 'SYDNEY_1',
  Tennis_1 = 'TENNIS_1',
  Theatre_1 = 'THEATRE_1',
  Tokyo_1 = 'TOKYO_1',
  TrackField_1 = 'TRACK_FIELD_1',
  TrackField_2 = 'TRACK_FIELD_2',
  Usa_1 = 'USA_1',
  Usa_2 = 'USA_2',
  Usa_3 = 'USA_3',
  Violin_1 = 'VIOLIN_1',
  Volleyball_1 = 'VOLLEYBALL_1',
  Walk_1 = 'WALK_1',
  WaterPolo_1 = 'WATER_POLO_1',
  Wedding_1 = 'WEDDING_1',
  Winter_1 = 'WINTER_1',
  Workout_1 = 'WORKOUT_1',
  Work_1 = 'WORK_1',
  Zebra_1 = 'ZEBRA_1',
  Zoo_1 = 'ZOO_1',
}

export type ScheduleHeaderImage = {
  id: ScheduleHeaderId;
  imageBaseUrl: Scalars['String']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
};

export enum ScheduleHeaderType {
  Ai = 'AI',
  Default = 'DEFAULT',
}

export type ScheduleLimits = {
  entryScheduledMessageCount: Scalars['Int']['output'];
  memberCount: Scalars['Int']['output'];
};

export type ScheduleOrganizationSeatPackRemovalInput = {
  organizationId: Scalars['ID']['input'];
  packs: Scalars['Int']['input'];
};

export type ScheduleSecret = {
  enabled: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
};

export type ScheduleTemplate = {
  headerBaseUrl: Scalars['String']['output'];
  headerIcons: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum ScheduleType {
  Availability = 'AVAILABILITY',
  Classic = 'CLASSIC',
  Conflict = 'CONFLICT',
  List = 'LIST',
  Magic = 'MAGIC',
}

export type ScheduleView = {
  type: ScheduleViewType;
};

export type ScheduleViewInput = {
  type: ScheduleViewType;
};

export enum ScheduleViewType {
  Agenda = 'AGENDA',
  Month = 'MONTH',
  Summary = 'SUMMARY',
  Week = 'WEEK',
}

export enum SchoolExperienceTag {
  Draft = 'DRAFT',
  HumanReviewed = 'HUMAN_REVIEWED',
  NeedsQa = 'NEEDS_QA',
  Parked = 'PARKED',
  PdfVerified = 'PDF_VERIFIED',
  Purchasable = 'PURCHASABLE',
}

export enum SchoolType {
  Alternative = 'ALTERNATIVE',
  CareerAndTechnical = 'CAREER_AND_TECHNICAL',
  Custom = 'CUSTOM',
  Regular = 'REGULAR',
  SpecialEducation = 'SPECIAL_EDUCATION',
}

export type SendEventInput = {
  email: Scalars['LowercaseString']['input'];
  eventId: Scalars['ID']['input'];
};

export type SetExperienceOrganizationPermissionInput = {
  experienceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  role: Role;
};

export type SetExperienceThemeInput = {
  experienceId: Scalars['ID']['input'];
  themeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetExperienceVisibilityInput = {
  experienceId: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
};

export type SetInteractionSlotInput = {
  blockId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['String']['input'];
  interactionAppId?: InputMaybe<Scalars['String']['input']>;
  slotIndex: Scalars['Int']['input'];
};

export type SetSchoolExperienceFundraiserImageInput = {
  experienceId: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
};

export type SetSchoolExperienceFundraiserInput = {
  experienceId: Scalars['ID']['input'];
  fundraiserName?: InputMaybe<Scalars['String']['input']>;
};

export type SetupChatInput = {
  chatId: Scalars['ID']['input'];
  timeZone: Scalars['TimeZone']['input'];
};

export enum SlotSize {
  Md = 'MD',
}

export type Snippet = {
  categories: Array<Category>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  entries: Array<Entry>;
  feedPublicUrl: Scalars['String']['output'];
  feeds: Array<Feed>;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  name: Scalars['String']['output'];
  scheduleId?: Maybe<Scalars['String']['output']>;
  scheduleTimeZone: Scalars['TimeZone']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  visibility: Visibility;
  whoLabels: Array<Label>;
};

export type SnippetEntriesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum Status {
  Active = 'ACTIVE',
  Anonymous = 'ANONYMOUS',
  Invited = 'INVITED',
}

export type SubscribeExperienceToCalendarInput = {
  calendarId: Scalars['String']['input'];
  experienceId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};

export type SubscribeToEventInput = {
  email: Scalars['LowercaseString']['input'];
  eventId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
};

export type SubscribeToExperienceInput = {
  email: Scalars['LowercaseString']['input'];
  experienceId: Scalars['ID']['input'];
  type: ExperienceSubscriptionTypes;
};

export type Subscription = {
  _empty?: Maybe<Scalars['String']['output']>;
  entriesAdded: Array<Entry>;
  entryAdded: Entry;
  entryDeleted: Scalars['ID']['output'];
  entryUpdated: Entry;
  scheduleOpened: Scalars['ID']['output'];
  scheduleUpdated: Schedule;
};

export type SubscriptionEntriesAddedArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type SubscriptionEntryAddedArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type SubscriptionEntryDeletedArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type SubscriptionEntryUpdatedArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type SubscriptionScheduleOpenedArgs = {
  scheduleId: Scalars['ID']['input'];
};

export type SubscriptionScheduleUpdatedArgs = {
  scheduleId: Scalars['ID']['input'];
};

export enum SubscriptionPlan {
  Business = 'BUSINESS',
  Family = 'FAMILY',
  Plus = 'PLUS',
}

export enum SubscriptionSource {
  Manual = 'MANUAL',
  Stripe = 'STRIPE',
  StripeOneTime = 'STRIPE_ONE_TIME',
}

export type SuggestTextMessageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  isOnDay: Scalars['Boolean']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  timeZone: Scalars['TimeZone']['input'];
  title: Scalars['String']['input'];
};

export type TemplateAccountExperience = {
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  template?: Maybe<ExperienceTemplate>;
  title: Scalars['String']['output'];
  type: ExperienceTypes;
};

export enum TimeDirection {
  After = 'AFTER',
  Before = 'BEFORE',
}

export enum TimeUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Weeks = 'WEEKS',
}

export enum TimeZoneDisplay {
  Event = 'EVENT',
  Experience = 'EXPERIENCE',
  Visitor = 'VISITOR',
}

export type ToggleExperienceSaveInput = {
  experienceId: Scalars['ID']['input'];
  saved: Scalars['Boolean']['input'];
};

export type TransferExperienceOwnershipInput = {
  experienceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type TransferOrganizationOwnershipInput = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UnpublishSchoolExperienceInput = {
  experienceId: Scalars['ID']['input'];
};

export type UnsetInteractionSlotInput = {
  blockId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['String']['input'];
  slotIndex: Scalars['Int']['input'];
};

export type UnsubscribeExperienceFromCalendarInput = {
  removeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type UnsubscribeFromEventInput = {
  eventId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
};

export type UpdateBlockInput = {
  blockId: Scalars['ID']['input'];
  layoutId?: InputMaybe<BlockLayouts>;
};

export type UpdateDistrictRequestInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};

export type UpdateEntryInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  entryId: Scalars['ID']['input'];
  exclusions?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  hidden?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  inclusions?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  labels?: InputMaybe<Array<LabelIdInput>>;
  locationWithPlace?: InputMaybe<LocationInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  recurrences: Array<RecurrenceInput>;
  scheduleId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  whoLabels?: InputMaybe<Array<LabelIdInput>>;
};

export type UpdateEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<EventDateInput>;
  eventId: Scalars['ID']['input'];
  for: EventFor;
  kind?: InputMaybe<EventItemKind>;
  locationWithPlace?: InputMaybe<LocationInput>;
  metadata?: InputMaybe<EventMetadataInput>;
  rrule?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<EventDateInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeType: DeliveryTimeType;
  eventMessageId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  fixedDeliveryTime?: InputMaybe<Scalars['DateTime']['input']>;
  fixedTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  hybridDeliveryTime?: InputMaybe<Scalars['LocalTime']['input']>;
  hybridRelativeTime?: InputMaybe<HybridRelativeTime>;
  hybridTimeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  instance?: InputMaybe<Scalars['DateTime']['input']>;
  recipients?: InputMaybe<Array<Scalars['Int']['input']>>;
  relativeTimeToEntryStart?: InputMaybe<Scalars['Int']['input']>;
  relativeTimeToEntryStartDirection?: InputMaybe<TimeDirection>;
  relativeTimeToEntryStartUnit?: InputMaybe<TimeUnit>;
  sendToEveryone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventMetadataInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  eventItemId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  hidden?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  kind?: InputMaybe<EventItemKind>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  whoLabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateExperienceCategoryInput = {
  categoryId: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  colorName?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExperienceCategorySortOrderInput = {
  categories: Array<CategorySortOrderInput>;
  experienceId: Scalars['ID']['input'];
};

export type UpdateExperienceInput = {
  accentBackgroundEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  attributionDisplay?: InputMaybe<AttributionOptions>;
  bannerDisplay?: InputMaybe<BannerOptions>;
  blocks?: InputMaybe<Array<UpdateBlockInput>>;
  bold?: InputMaybe<Scalars['Int']['input']>;
  colorLegendEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  colorMode?: InputMaybe<ExperienceColorMode>;
  colorPalette?: InputMaybe<Scalars['String']['input']>;
  colorType?: InputMaybe<ColorTypes>;
  customAlpha?: InputMaybe<Scalars['Float']['input']>;
  customHue?: InputMaybe<Scalars['Int']['input']>;
  customLightness?: InputMaybe<Scalars['Int']['input']>;
  customSaturation?: InputMaybe<Scalars['Int']['input']>;
  datesInPrimaryColor?: InputMaybe<Scalars['Boolean']['input']>;
  defaultChildExperienceId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardCategoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardDescriptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardEmojiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardEndTimeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardLabelsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardLayoutId?: InputMaybe<EventCardLayouts>;
  eventCardLocationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardStartTimeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardTruncateNamesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventCardYearEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventListDisplay?: InputMaybe<EventListDisplay>;
  eventListEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventListStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventTextSize?: InputMaybe<EventTextSizes>;
  eventTitlePrefix?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ID']['input'];
  headerTitleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerTitleSize?: InputMaybe<HeaderTitleSizes>;
  heroDisplay?: InputMaybe<HeroOptions>;
  highlightToday?: InputMaybe<Scalars['Boolean']['input']>;
  hue?: InputMaybe<Scalars['Int']['input']>;
  layoutId?: InputMaybe<ExperienceLayouts>;
  lightness?: InputMaybe<Scalars['Int']['input']>;
  logoDisplay?: InputMaybe<LogoOptions>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  muteWeekendDatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  printableConfig?: InputMaybe<PrintableConfigInput>;
  saturation?: InputMaybe<Scalars['Int']['input']>;
  shadeWeekendsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sparkle?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<ExperienceStyles>;
  styleId?: InputMaybe<Scalars['String']['input']>;
  subscribeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timeFormat?: InputMaybe<ExperienceTimeFormat>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timeZoneDisplay?: InputMaybe<TimeZoneDisplay>;
  title?: InputMaybe<Scalars['String']['input']>;
  vibe?: InputMaybe<ExperienceVibe>;
  weekStartDay?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateExperienceLabelInput = {
  experienceId: Scalars['ID']['input'];
  labelId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type UpdateExperienceLabelSortOrderInput = {
  experienceId: Scalars['ID']['input'];
  labels: Array<LabelSortOrderInput>;
};

export type UpdateExperiencePermissionInput = {
  experienceId: Scalars['ID']['input'];
  role: Role;
  userId: Scalars['ID']['input'];
};

export type UpdateExperienceSlugInput = {
  experienceId: Scalars['String']['input'];
  slug: Scalars['LowercaseString']['input'];
};

export type UpdateFeedForExperienceInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ID']['input'];
  feedId: Scalars['ID']['input'];
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  whoLabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateOrganizationInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationMemberInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateOrganizationMemberRoleInput = {
  organizationId: Scalars['ID']['input'];
  role: OrganizationRole;
  userId: Scalars['ID']['input'];
};

export type UpdatePrintableForChatInput = {
  chatId: Scalars['ID']['input'];
  config: ChatPrintableConfigInput;
};

export type UpdateSlotInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  interactionAppId?: InputMaybe<Scalars['String']['input']>;
  slotIndex: Scalars['Int']['input'];
};

export type UpdateSourceForExperienceInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ID']['input'];
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  whoLabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UploadFileForChatInput = {
  base64File: Base64FileInput;
  chatId: Scalars['ID']['input'];
};

export type UploadImageForEventInput = {
  eventId: Scalars['ID']['input'];
  for: EventFor;
  image: Scalars['Upload']['input'];
};

export type UploadImageForExperienceInput = {
  experienceId: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
  type: ExperienceImageTypes;
};

export type User = {
  avatar: Scalars['String']['output'];
  campaign?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['LowercaseString']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identityStrategies: Array<IdentityStrategy>;
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  magicFileCreditsRemaining?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizations: Array<Organization>;
  plannerLicenses: Array<PlannerLicense>;
  preferredPlatform?: Maybe<PlatformTypes>;
  rolePermissions: RolePermissions;
  schedules: Array<Schedule>;
  settings: Array<UserSetting>;
  status: Status;
  /** @deprecated Use the personal organization's subscriptionCurrentPeriodEnd instead */
  subscriptionCurrentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use the personal organization's subscriptionSource instead */
  subscriptionSource?: Maybe<SubscriptionSource>;
  /** @deprecated Use the personal organization's subscriptionStatus instead */
  subscriptionStatus?: Maybe<UserSubscriptionStatus>;
  suspendedAt?: Maybe<Scalars['DateTime']['output']>;
  tier: UserTier;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserPermission = {
  avatar: Scalars['String']['output'];
  email?: Maybe<Scalars['LowercaseString']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type UserPermissionInput = {
  email: Scalars['LowercaseString']['input'];
  role: Role;
};

export type UserPermissions = {
  all: Array<UserPermission>;
  organizations: Array<ExperienceOrganizationPermission>;
  role: Role;
};

export type UserSetting = {
  name: UserSettingName;
  value: Scalars['Mixed']['output'];
};

export enum UserSettingName {
  DidCompleteOnboarding = 'DID_COMPLETE_ONBOARDING',
  EnabledScheduleTypes = 'ENABLED_SCHEDULE_TYPES',
}

export enum UserSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID',
}

export enum UserTier {
  Free = 'FREE',
  Pro = 'PRO',
}

export type ViewerFeedDestinationsInput = {
  experienceId: Scalars['ID']['input'];
};

export enum ViewerPermissions {
  AddToCalendar = 'ADD_TO_CALENDAR',
  Rsvp = 'RSVP',
  ScheduleView = 'SCHEDULE_VIEW',
  SnippetView = 'SNIPPET_VIEW',
}

export enum Visibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export const namedOperations = {
  Query: {
    GetPendingInvitations: 'GetPendingInvitations',
    AccountDeletionPreview: 'AccountDeletionPreview',
    GetOrganizationInvites: 'GetOrganizationInvites',
    GetOrganizationMembers: 'GetOrganizationMembers',
    GetAuthAction: 'GetAuthAction',
    GetProfile: 'GetProfile',
    GetCanvaExportJob: 'GetCanvaExportJob',
    GetCanvaDesigns: 'GetCanvaDesigns',
    GetEventMessageRecipients: 'GetEventMessageRecipients',
    GetEventMessages: 'GetEventMessages',
    GetEventForExperience: 'GetEventForExperience',
    GetPageExperienceEvents: 'GetPageExperienceEvents',
    GetPublishedPageExperienceEvents: 'GetPublishedPageExperienceEvents',
    GetExperienceEventMessages: 'GetExperienceEventMessages',
    GetExperienceChildConfigs: 'GetExperienceChildConfigs',
    GetLayout: 'GetLayout',
    GetPageExperience: 'GetPageExperience',
    GetPublishedChildExperience: 'GetPublishedChildExperience',
    GetPublishedPageExperience: 'GetPublishedPageExperience',
    PreviewMagicExperience: 'PreviewMagicExperience',
    GetMagicChat: 'GetMagicChat',
    GetMagicJob: 'GetMagicJob',
    PollMagicJobStatus: 'PollMagicJobStatus',
    CheckSlugAvailability: 'CheckSlugAvailability',
    GetExperienceCollaborators: 'GetExperienceCollaborators',
    PreviewExperiencePermissionRemoval: 'PreviewExperiencePermissionRemoval',
    GetCustomArtifact: 'GetCustomArtifact',
    GetPublishedCustomArtifact: 'GetPublishedCustomArtifact',
    GetPrintableConfigInfo: 'GetPrintableConfigInfo',
    GetExperienceThemes: 'GetExperienceThemes',
    GetAppConfig: 'GetAppConfig',
    GetScheduleTemplates: 'GetScheduleTemplates',
    GetSchedules: 'GetSchedules',
    GetLibrary: 'GetLibrary',
    GetLibraryWithEvent: 'GetLibraryWithEvent',
    GetQuickEntriesPage: 'GetQuickEntriesPage',
    VerifyResetToken: 'VerifyResetToken',
    PollEntriesJobStatus: 'PollEntriesJobStatus',
    GetScheduleFeed: 'GetScheduleFeed',
    GetEntryInvites: 'GetEntryInvites',
    GetMessagesForEntry: 'GetMessagesForEntry',
    GetScheduleHeaderImages: 'GetScheduleHeaderImages',
    GetScheduleEntries: 'GetScheduleEntries',
    GetSchedule: 'GetSchedule',
    GetIntegrations: 'GetIntegrations',
    GetScheduleCollaborators: 'GetScheduleCollaborators',
    GetScheduleMembers: 'GetScheduleMembers',
    GetEntry: 'GetEntry',
    GetEntryForMessage: 'GetEntryForMessage',
    GetScheduleEntryMessages: 'GetScheduleEntryMessages',
    GetSnippet: 'GetSnippet',
    GetSnippets: 'GetSnippets',
    GetInternalFeeds: 'GetInternalFeeds',
    GetIcsFeeds: 'GetIcsFeeds',
    GetFeedSource: 'GetFeedSource',
    GetScheduleFeeds: 'GetScheduleFeeds',
    GetAvailabilityResponses: 'GetAvailabilityResponses',
    FindDistricts: 'FindDistricts',
    GetDistrictRequests: 'GetDistrictRequests',
    GetExperienceUpdateRequesters: 'GetExperienceUpdateRequesters',
    GetTemplateAccountExperiences: 'GetTemplateAccountExperiences',
  },
  Mutation: {
    AcceptOrganizationInvite: 'AcceptOrganizationInvite',
    ChangePassword: 'ChangePassword',
    UpdateProfile: 'UpdateProfile',
    DeleteAccount: 'DeleteAccount',
    AddOrganizationSeatPacks: 'AddOrganizationSeatPacks',
    CancelOrganizationSeatPackRemoval: 'CancelOrganizationSeatPackRemoval',
    InviteOrganizationMembers: 'InviteOrganizationMembers',
    RemoveOrganizationMember: 'RemoveOrganizationMember',
    ResendOrganizationInvite: 'ResendOrganizationInvite',
    RevokeOrganizationInvite: 'RevokeOrganizationInvite',
    ScheduleOrganizationSeatPackRemoval: 'ScheduleOrganizationSeatPackRemoval',
    UpdateOrganization: 'UpdateOrganization',
    UpdateOrganizationMember: 'UpdateOrganizationMember',
    Login: 'Login',
    Register: 'Register',
    RequestEmailLoginCode: 'RequestEmailLoginCode',
    VerifyEmailLoginCode: 'VerifyEmailLoginCode',
    SetInitialName: 'SetInitialName',
    CreateCanvaExportJob: 'CreateCanvaExportJob',
    CreateExperienceCategory: 'CreateExperienceCategory',
    CreateExperienceLabel: 'CreateExperienceLabel',
    DeleteExperienceCategory: 'DeleteExperienceCategory',
    DeleteExperienceLabel: 'DeleteExperienceLabel',
    UpdateExperienceCategory: 'UpdateExperienceCategory',
    UpdateExperienceCategorySortOrder: 'UpdateExperienceCategorySortOrder',
    UpdateEventMetadata: 'UpdateEventMetadata',
    UpdateExperienceLabel: 'UpdateExperienceLabel',
    UpdateExperienceLabelSortOrder: 'UpdateExperienceLabelSortOrder',
    CreateEventMessage: 'CreateEventMessage',
    DeleteEventMessage: 'DeleteEventMessage',
    UpdateEventMessage: 'UpdateEventMessage',
    DeleteEvent: 'DeleteEvent',
    UploadImageForEvent: 'UploadImageForEvent',
    RemoveImageForEvent: 'RemoveImageForEvent',
    RemoveEvent: 'RemoveEvent',
    UpdateEvent: 'UpdateEvent',
    CreateEvents: 'CreateEvents',
    CopyExperience: 'CopyExperience',
    CreateChildExperience: 'CreateChildExperience',
    CreateExperience: 'CreateExperience',
    CreatePlannerFromPrompt: 'CreatePlannerFromPrompt',
    CreateSchoolExperience: 'CreateSchoolExperience',
    CreateShortTitles: 'CreateShortTitles',
    DeleteChildExperience: 'DeleteChildExperience',
    DeleteEventsFromSchoolExperience: 'DeleteEventsFromSchoolExperience',
    DeleteExperience: 'DeleteExperience',
    FlagNoSchoolEvents: 'FlagNoSchoolEvents',
    ImportChat: 'ImportChat',
    ImportMagicJob: 'ImportMagicJob',
    MoveExperienceToOrganization: 'MoveExperienceToOrganization',
    QaSchoolExperience: 'QaSchoolExperience',
    RemoveImageForExperience: 'RemoveImageForExperience',
    RemoveSchoolExperienceFundraiserImage:
      'RemoveSchoolExperienceFundraiserImage',
    RequestExperienceAccess: 'RequestExperienceAccess',
    SetAddToCalendarConfig: 'SetAddToCalendarConfig',
    SetSchoolExperienceFundraiser: 'SetSchoolExperienceFundraiser',
    SetSchoolExperienceFundraiserImage: 'SetSchoolExperienceFundraiserImage',
    ToggleExperienceSave: 'ToggleExperienceSave',
    UpdateExperience: 'UpdateExperience',
    UploadImageForExperience: 'UploadImageForExperience',
    CreateMagicEntry: 'CreateMagicEntry',
    SaveEvent: 'SaveEvent',
    SaveEvents: 'SaveEvents',
    ExportEvents: 'ExportEvents',
    SubscribeExperienceToCalendar: 'SubscribeExperienceToCalendar',
    SubscribeToEvent: 'SubscribeToEvent',
    SubscribeToExperience: 'SubscribeToExperience',
    UnsubscribeExperienceFromCalendar: 'UnsubscribeExperienceFromCalendar',
    ExportQuickEntries: 'ExportQuickEntries',
    CompleteMagicJob: 'CompleteMagicJob',
    SetupChat: 'SetupChat',
    UploadFileForChat: 'UploadFileForChat',
    CreateChat: 'CreateChat',
    RateMagicJob: 'RateMagicJob',
    CreateMagicJob: 'CreateMagicJob',
    RepeatMagicJob: 'RepeatMagicJob',
    AddCollaboratorToExperience: 'AddCollaboratorToExperience',
    LeaveExperience: 'LeaveExperience',
    RemoveExperienceCollaborator: 'RemoveExperienceCollaborator',
    RemoveExperienceOrganizationPermission:
      'RemoveExperienceOrganizationPermission',
    SetExperienceOrganizationPermission: 'SetExperienceOrganizationPermission',
    SetExperienceVisibility: 'SetExperienceVisibility',
    TransferExperienceOwnership: 'TransferExperienceOwnership',
    UpdateExperienceCollaborator: 'UpdateExperienceCollaborator',
    UpdateExperienceSlug: 'UpdateExperienceSlug',
    AddFeedToExperience: 'AddFeedToExperience',
    AddSourceToExperience: 'AddSourceToExperience',
    RefreshSourceForExperience: 'RefreshSourceForExperience',
    RemoveFeedFromExperience: 'RemoveFeedFromExperience',
    RequestFeedAccess: 'RequestFeedAccess',
    UpdateFeedForExperience: 'UpdateFeedForExperience',
    UpdateSourceForExperience: 'UpdateSourceForExperience',
    SetExperienceTheme: 'SetExperienceTheme',
    CreateSchedule: 'CreateSchedule',
    CreateScheduleFromTemplate: 'CreateScheduleFromTemplate',
    DeleteSchedule: 'DeleteSchedule',
    LeaveSchedule: 'LeaveSchedule',
    Logout: 'Logout',
    RemoveIntegration: 'RemoveIntegration',
    RequestAccess: 'RequestAccess',
    RequestEmailVerification: 'RequestEmailVerification',
    SetPreferredPlatform: 'SetPreferredPlatform',
    RenameLibraryItem: 'RenameLibraryItem',
    SendEvent: 'SendEvent',
    SendQuickEntry: 'SendQuickEntry',
    ResetPassword: 'ResetPassword',
    RequestResetPassword: 'RequestResetPassword',
    CreateSnippet: 'CreateSnippet',
    createEntriesJobFromFile: 'createEntriesJobFromFile',
    CreateEntriesJobFromPrompt: 'CreateEntriesJobFromPrompt',
    PublishJobEntries: 'PublishJobEntries',
    AddMember: 'AddMember',
    GenerateScheduleFeedSecret: 'GenerateScheduleFeedSecret',
    ToggleScheduleFeedEnabled: 'ToggleScheduleFeedEnabled',
    CreateCategory: 'CreateCategory',
    DeleteCategory: 'DeleteCategory',
    UpdateCategory: 'UpdateCategory',
    UpdateCategorySortOrder: 'UpdateCategorySortOrder',
    CopyPublicSchedule: 'CopyPublicSchedule',
    SuggestTextMessage: 'SuggestTextMessage',
    ToggleRsvp: 'ToggleRsvp',
    UpdateRsvpSettings: 'UpdateRsvpSettings',
    CreateLabel: 'CreateLabel',
    DeleteLabel: 'DeleteLabel',
    UpdateLabel: 'UpdateLabel',
    UpdateLabelSortOrder: 'UpdateLabelSortOrder',
    SubmitMemberForm: 'SubmitMemberForm',
    SetupSchedule: 'SetupSchedule',
    RSVP: 'RSVP',
    UpdateScheduleHeader: 'UpdateScheduleHeader',
    EnableScheduleHeader: 'EnableScheduleHeader',
    UpdateScheduleSettings: 'UpdateScheduleSettings',
    AddCollaboratorToSchedule: 'AddCollaboratorToSchedule',
    RemoveCollaborator: 'RemoveCollaborator',
    TogglePublicSchedule: 'TogglePublicSchedule',
    TransferOwnership: 'TransferOwnership',
    UpdateCollaborator: 'UpdateCollaborator',
    CopySchedule: 'CopySchedule',
    CreateEntry: 'CreateEntry',
    CreateEntryMessage: 'CreateEntryMessage',
    CreateEntryMessages: 'CreateEntryMessages',
    DeleteEntry: 'DeleteEntry',
    DeleteEntryMessage: 'DeleteEntryMessage',
    FollowEntry: 'FollowEntry',
    RemoveMember: 'RemoveMember',
    RenameSchedule: 'RenameSchedule',
    ToggleScheduleHeaderEnabled: 'ToggleScheduleHeaderEnabled',
    ToggleScheduleSave: 'ToggleScheduleSave',
    UnfollowEntry: 'UnfollowEntry',
    UpdateEntry: 'UpdateEntry',
    UpdateEntryMessage: 'UpdateEntryMessage',
    UpdateSchedule: 'UpdateSchedule',
    UpdateSnippetVisibility: 'UpdateSnippetVisibility',
    DeleteSnippet: 'DeleteSnippet',
    UpdateSnippet: 'UpdateSnippet',
    AddSourceToSchedule: 'AddSourceToSchedule',
    RefreshFeed: 'RefreshFeed',
    RemoveFeedFromSchedule: 'RemoveFeedFromSchedule',
    UpdateFeed: 'UpdateFeed',
    SubmitAvailabilityResponse: 'SubmitAvailabilityResponse',
    AddTagToSchoolExperience: 'AddTagToSchoolExperience',
    AssignDistrictToDistrictRequest: 'AssignDistrictToDistrictRequest',
    CreateDistrict: 'CreateDistrict',
    CreateDistrictRequest: 'CreateDistrictRequest',
    EditDistrict: 'EditDistrict',
    PublishSchoolExperience: 'PublishSchoolExperience',
    RemoveTagFromSchoolExperience: 'RemoveTagFromSchoolExperience',
    UnpublishSchoolExperience: 'UnpublishSchoolExperience',
    UpdateDistrictRequest: 'UpdateDistrictRequest',
    DisableExperienceTemplate: 'DisableExperienceTemplate',
    EnableExperienceTemplate: 'EnableExperienceTemplate',
    RequestScheduleAccess: 'RequestScheduleAccess',
  },
  Subscription: {
    EntriesAdded: 'EntriesAdded',
    EntryAdded: 'EntryAdded',
    EntryDeleted: 'EntryDeleted',
    EntryUpdated: 'EntryUpdated',
    ScheduleOpened: 'ScheduleOpened',
    Schedule: 'Schedule',
  },
  Fragment: {
    CanvaExportJobFragment: 'CanvaExportJobFragment',
    EventExport: 'EventExport',
    ExperienceEvent: 'ExperienceEvent',
    ExperienceJob: 'ExperienceJob',
    MagicEvent: 'MagicEvent',
    LayoutDefinition: 'LayoutDefinition',
    PageExperience: 'PageExperience',
    MagicChat: 'MagicChat',
    MagicJob: 'MagicJob',
    Theme: 'Theme',
    MinimumEntryFields: 'MinimumEntryFields',
    Entry: 'Entry',
    Profile: 'Profile',
    Schedule: 'Schedule',
    EntriesContextFragment: 'EntriesContextFragment',
    Snippet: 'Snippet',
    Feed: 'Feed',
  },
};
